var $8zHUo$reactjsxruntime = require('react/jsx-runtime');
var $8zHUo$react = require('react');
var $8zHUo$phpcreationfrontendcomponentsreact = require('@phpcreation/frontend-components-react');
var $8zHUo$tanstackreactquery = require('@tanstack/react-query');
var $8zHUo$axios = require('axios');
var $8zHUo$cookiesnext = require('cookies-next');
var $8zHUo$reacthottoast = require('react-hot-toast');
var $8zHUo$nextrouter = require('next/router');
var $8zHUo$reactintl = require('react-intl');
var $8zHUo$zustand = require('zustand');
var $8zHUo$zustandmiddleware = require('zustand/middleware');
var $8zHUo$xlsx = require('xlsx');
var $8zHUo$nextlink = require('next/link');
var $8zHUo$lodash = require('lodash');
var $8zHUo$htmlreactparser = require('html-react-parser');
var $8zHUo$reactjoyride = require('react-joyride');
var $8zHUo$moment = require('moment');
var $8zHUo$nexthead = require('next/head');
var $8zHUo$tanstackreactquerydevtools = require('@tanstack/react-query-devtools');

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true,
  });
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

$parcel$export(
  module.exports,
  'Listing',
  () => $d77c90b328b7f9e7$export$2e2bcd8739ae039
);
$parcel$export(
  module.exports,
  'Create',
  () => $9a6c41ceee585a48$export$2e2bcd8739ae039
);
$parcel$export(
  module.exports,
  'Edit',
  () => $058824ee56add146$export$2e2bcd8739ae039
);
$parcel$export(
  module.exports,
  'Show',
  () => $8a73ef8dafb8b269$export$2e2bcd8739ae039
);
$parcel$export(
  module.exports,
  'Dashboard',
  () => $babf57e211862dcf$export$2e2bcd8739ae039
);
$parcel$export(
  module.exports,
  'Login',
  () => $d916a442134b0b1f$export$2e2bcd8739ae039
);
$parcel$export(
  module.exports,
  'Status',
  () => $b8f3178562702f6a$export$2e2bcd8739ae039
);
$parcel$export(
  module.exports,
  'TableListing',
  () => $c092319464fa2356$export$2e2bcd8739ae039
);
$parcel$export(
  module.exports,
  'AppContextProvider',
  () => $c022715bc9d219e1$export$2e2bcd8739ae039
);
// Bigger components

//interceptors for  api calls

const $c7d5b4ea505ed32f$var$axiosConfigApiInstance = (0,
$parcel$interopDefault($8zHUo$axios)).create();
// set the base url
$c7d5b4ea505ed32f$var$axiosConfigApiInstance.defaults.baseURL =
  process.env.NEXT_PUBLIC_CONFIG_CRUD;
// would be usefull if we have a way to store the token
// Request interceptor for API calls
$c7d5b4ea505ed32f$var$axiosConfigApiInstance.interceptors.request.use(
  async config => {
    let jwt = (0, $8zHUo$cookiesnext.getCookie)('CRUD_TOKEN');
    config.headers = {
      Authorization: `Bearer ` + jwt,
    };
    return config;
  },
  error => {
    Promise.reject(error);
  }
);
$c7d5b4ea505ed32f$var$axiosConfigApiInstance.interceptors.response.use(
  response => {
    return response;
  },
  async error => {
    const status = error.response ? error.response.status : null;
    const original_req = error.config;
    original_req.headers['Conent-Type'] = `application/json; Charset=UTF-8`;
    // retry untill not status 401
    if (status == 401) {
      if (!window.location.href.includes('login')) {
        (0, $8zHUo$cookiesnext.deleteCookie)('CRUD_TOKEN');
        window.location.href = '/login?from=' + window.location.pathname;
      }
    }
    return Promise.reject(error);
  }
);
var $c7d5b4ea505ed32f$export$2e2bcd8739ae039 =
  $c7d5b4ea505ed32f$var$axiosConfigApiInstance; // Set default headers to common_axios ( as Instance )

const $64fb6a6b423817c8$export$c542b5e295206b2a = () => {
  return 'hello ';
};
const $64fb6a6b423817c8$var$checker_multi = (value, field, Default) => {
  if (value != null || value != undefined) {
    // case of muliple values '?id[]=2&id[]=3'
    if (value.toString().split(',').length > 1) {
      let exp = '';
      let arr = value.toString().split(',');
      for (let i = 0; i < arr.length; i++) {
        exp = exp + field + '[]=' + arr[i];
        if (i < arr.length - 1) exp = exp + '&';
      }
      return exp;
    }
    // case simple value
    return value + '&';
  }
  return Default ?? '';
};
const $64fb6a6b423817c8$var$get_specifics = obj => {
  if (!obj) return '';
  // returned epression
  let exp = '';
  // lets get the object keys as an array elements : {id:1,tenant:2} =>['id','tenant']
  let arr_props = Object.keys(obj);
  //@ts-ignore
  // now We will iterate through the keys of the object aka elements of the array of props
  for (let i = 0; i < arr_props.length; i++) {
    // in case the property value is not '2,3' but only a single value
    //@ts-ignore
    if (obj[arr_props[i]].toString().split(',').length == 1) {
      exp =
        exp +
        arr_props[i] +
        '=' + //@ts-ignore
        $64fb6a6b423817c8$var$checker_multi(
          obj[arr_props[i]].toString(),
          arr_props[i],
          ''
        );
      continue;
    }
    //@ts-ignore
    exp =
      exp +
      $64fb6a6b423817c8$var$checker_multi(
        obj[arr_props[i]].toString(),
        arr_props[i],
        ''
      );
    if (i < arr_props.length - 1) exp = exp + '&';
  }
  return exp;
};
const $64fb6a6b423817c8$export$1b5b3a9374f6630e = (resource, filters) => {
  const {
    q: q,
    id: id,
    specific: specific,
    page: page,
    pageSize: pageSize,
    limit: limit,
    offset: offset,
    sort: sort,
    order: order,
    qField: qField,
  } = filters;
  // SEARCH COLUMN IS __HARDCODED
  let query_params = `page=${$64fb6a6b423817c8$var$checker_multi(
    page,
    'page',
    1
  )}&range=${$64fb6a6b423817c8$var$checker_multi(
    pageSize,
    'range',
    25
  )}&limit=${$64fb6a6b423817c8$var$checker_multi(
    limit
  )}&order%5B${sort}%5D=${order}&offset=${$64fb6a6b423817c8$var$checker_multi(
    offset
  )}${$64fb6a6b423817c8$var$checker_multi(
    id
  )}&${$64fb6a6b423817c8$var$get_specifics(specific)}`;
  if (q)
    query_params += `&search=${$64fb6a6b423817c8$var$checker_multi(q, '')}`;
  return query_params;
};
function $64fb6a6b423817c8$export$5ea1bdf6a9d3779f(formData, formInputs) {
  let newFormData = {};
  formInputs.forEach(item => {
    if (item.type == 'text') {
      if (item.prefixOnSubmit)
        // @ts-ignore
        newFormData[item.name] = item.prefixOnSubmit + formData[item.name];
      // @ts-ignore
      else newFormData[item.name] = formData[item.name];
    }
    if (item.type == 'select_async') {
      if (item.prefixOnSubmit)
        // @ts-ignore
        newFormData[item.name] = // @ts-ignore
          item.prefixOnSubmit + formData[item.name].value;
      else newFormData[item.name] = formData[item.name].value;
    }
    if (item.type == 'select_multi' && item.isMulti == true) {
      if (item.prefixOnSubmit)
        // @ts-ignore
        newFormData[item.name] = item.prefixOnSubmit + formData[item.name];
      // @ts-ignore
      else newFormData[item.name] = formData[item.name];
    }
    if (item.type == 'select') {
      if (item.prefixOnSubmit)
        // @ts-ignore
        newFormData[item.name] = // @ts-ignore
          item.prefixOnSubmit + formData[item.name].value;
      else newFormData[item.name] = formData[item.name].value;
    }
    if (item.type == 'checkbox') {
      if (item.prefixOnSubmit)
        // @ts-ignore
        newFormData[item.name] = item.prefixOnSubmit + formData[item.name];
      // @ts-ignore
      else newFormData[item.name] = formData[item.name];
    }
    if (item.type == 'input') {
      if (item.prefixOnSubmit)
        // @ts-ignore
        newFormData[item.name] = item.prefixOnSubmit + formData[item.name];
      // @ts-ignore
      else newFormData[item.name] = formData[item.name];
    }
    if (item.type == 'number') {
      if (item.prefixOnSubmit)
        // @ts-ignore
        newFormData[item.name] = item.prefixOnSubmit + formData[item.name];
      // @ts-ignore
      else newFormData[item.name] = formData[item.name];
    }
    if (item.type == 'date') {
      if (item.prefixOnSubmit)
        // @ts-ignore
        newFormData[item.name] = item.prefixOnSubmit + formData[item.name];
      // @ts-ignore
      else newFormData[item.name] = formData[item.name];
    }
    if (item.type == 'email') {
      if (item.prefixOnSubmit)
        // @ts-ignore
        newFormData[item.name] = item.prefixOnSubmit + formData[item.name];
      // @ts-ignore
      else newFormData[item.name] = formData[item.name];
    }
    if (item.type == 'phone') {
      if (item.prefixOnSubmit)
        // @ts-ignore
        newFormData[item.name] = item.prefixOnSubmit + formData[item.name];
      // @ts-ignore
      else newFormData[item.name] = formData[item.name];
    }
  });
  return newFormData;
}

const $686ab0e2fb05f109$export$6079a388768cd3b7 = async (
  resource,
  filters,
  raw
) => {
  let url = `/${resource}?${(0, $64fb6a6b423817c8$export$1b5b3a9374f6630e)(
    resource,
    filters
  )}`;
  return (0, $c7d5b4ea505ed32f$export$2e2bcd8739ae039).get(url).then(res => {
    if (raw) return res.data;
    return res.data['hydra:member'];
  });
};
const $686ab0e2fb05f109$export$7d1eefcddaeba55b = async (resource, id) =>
  (0, $c7d5b4ea505ed32f$export$2e2bcd8739ae039)
    .get(`/${resource}/${id}`)
    .then(res => res.data);
const $686ab0e2fb05f109$export$1041b7558d56f2f9 = (resource, data) =>
  (0, $c7d5b4ea505ed32f$export$2e2bcd8739ae039)
    .post(`/${resource}`, data)
    .then(res => res.data);
const $686ab0e2fb05f109$export$c1f5dc8a6d873266 = (resource, id) =>
  (0, $c7d5b4ea505ed32f$export$2e2bcd8739ae039)
    .delete(`/${resource}/${id}`)
    .then(res => res.data['hydra:member']);
const $686ab0e2fb05f109$export$b9757da0c8d7c3bb = (resource, data) =>
  (0, $c7d5b4ea505ed32f$export$2e2bcd8739ae039)
    .put(`/${resource}/${data.id}`, data)
    .then(res => res.data['hydra:member']);

function $49eb772184ca2f2b$export$ad6724ecf32710ae(resource, filters, raw) {
  return (0, $8zHUo$tanstackreactquery.useQuery)(
    [resource, 'list', filters, raw],
    () => (0, $686ab0e2fb05f109$export$6079a388768cd3b7)(resource, filters, raw)
  );
}
function $49eb772184ca2f2b$export$35d0477f0729096c(resource, resource_id) {
  return (0, $8zHUo$tanstackreactquery.useQuery)(
    [resource, 'detail', resource_id],
    () => (0, $686ab0e2fb05f109$export$7d1eefcddaeba55b)(resource, resource_id)
  );
}
function $49eb772184ca2f2b$export$5edc9d665968dd86(resource) {
  const queryClient = (0, $8zHUo$tanstackreactquery.useQueryClient)();
  return (0, $8zHUo$tanstackreactquery.useMutation)(
    [resource],
    data => (0, $686ab0e2fb05f109$export$1041b7558d56f2f9)(resource, data),
    {
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries([resource]);
        (0, $parcel$interopDefault($8zHUo$reacthottoast)).success(
          'Successfuly created!'
        );
      },
      onError: (data, variables) => {
        queryClient.invalidateQueries([resource]);
        (0, $parcel$interopDefault($8zHUo$reacthottoast)).error(
          'Something went wrong!'
        );
      },
    }
  );
}
function $49eb772184ca2f2b$export$74524c73191a667c(resource) {
  const queryClient = (0, $8zHUo$tanstackreactquery.useQueryClient)();
  return (0, $8zHUo$tanstackreactquery.useMutation)(
    [resource],
    data => (0, $686ab0e2fb05f109$export$b9757da0c8d7c3bb)(resource, data),
    {
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries([resource]);
        (0, $parcel$interopDefault($8zHUo$reacthottoast)).success(
          'Successfuly updated!'
        );
      },
      onError: (data, variables) => {
        queryClient.invalidateQueries([resource]);
        (0, $parcel$interopDefault($8zHUo$reacthottoast)).error(
          'Something went wrong!'
        );
      },
    }
  );
}
function $49eb772184ca2f2b$export$60acb8fd13afd60d(resource) {
  const queryClient = (0, $8zHUo$tanstackreactquery.useQueryClient)();
  return (0, $8zHUo$tanstackreactquery.useMutation)(
    [resource],
    id => (0, $686ab0e2fb05f109$export$c1f5dc8a6d873266)(resource, id),
    {
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries([resource]);
        (0, $parcel$interopDefault($8zHUo$reacthottoast)).success(
          'Successfuly deleted!'
        );
      },
      onError: (data, variables) => {
        queryClient.invalidateQueries([resource]);
        (0, $parcel$interopDefault($8zHUo$reacthottoast)).error(
          'Something went wrong!'
        );
      },
    }
  );
}

const $82c7348de3dc7374$var$useTranslation = () => {
  const trans = (0, $8zHUo$reactintl.useIntl)();
  const t = id => trans.messages[id];
  return {
    t: id => (trans.messages[id] ? trans.messages[id].toString() : id),
    ...trans,
  };
};
var $82c7348de3dc7374$export$2e2bcd8739ae039 =
  $82c7348de3dc7374$var$useTranslation;

const $be91cef85354cc3d$var$useListingStore = (0, $8zHUo$zustand.create)(
  (0, $8zHUo$zustandmiddleware.combine)(
    {
      filters: {
        specific: {},
        id: null,
        q: null,
        limit: null,
        page: null,
        pageSize: 25,
        offset: null,
        sort: undefined,
        order: undefined,
        qField: 'id',
      },
      fields: [],
      selectedActions: [],
    },
    set => ({
      setSpecific: (field, value) =>
        set(s => {
          const obj = {
            filters: {
              ...s.filters,
            },
          };
          //@ts-ignore
          obj.filters.specific[field] = value;
          return obj;
        }),
      setId: givenId =>
        set(s => ({
          filters: {
            ...s.filters,
            id: givenId,
          },
        })),
      setQ: query =>
        set(s => ({
          filters: {
            ...s.filters,
            q: query,
          },
        })),
      setQField: qfield =>
        set(s => ({
          filters: {
            ...s.filters,
            qField: qfield,
          },
        })),
      setSort: field =>
        set(s => ({
          filters: {
            ...s.filters,
            sort: field,
          },
        })),
      setOrder: order =>
        set(s => ({
          filters: {
            ...s.filters,
            order: order,
          },
        })),
      setPage: page =>
        set(s => ({
          filters: {
            ...s.filters,
            page: page,
          },
        })),
      setPageSize: pageSize =>
        set(s => ({
          filters: {
            ...s.filters,
            pageSize: pageSize,
          },
        })),
      setOffset: offset =>
        set(s => ({
          filters: {
            ...s.filters,
            offset: offset,
          },
        })),
      setSelectedActions: actions =>
        set(s => ({
          selectedActions: actions,
        })),
      setLimit: limit =>
        set(s => ({
          filters: {
            ...s.filters,
            limit: limit,
          },
        })),
      setFields: fields =>
        set({
          fields: fields,
        }),
      addField: f =>
        set(s => ({
          fields: s.fields?.concat([f]),
        })),
      removeField: f =>
        set(s => ({
          fields: s.fields?.filter(elt => elt !== f),
        })),
      clearFilters: () =>
        set({
          filters: {
            specific: {},
            id: null,
            q: null,
            limit: undefined,
            page: undefined,
            offset: undefined,
            sort: undefined,
            order: undefined,
            pageSize: 25,
            qField: 'id',
          },
        }),
      clearAll: () =>
        set({
          filters: {
            specific: {},
            id: null,
            q: null,
            limit: undefined,
            page: undefined,
            offset: undefined,
            sort: undefined,
            order: undefined,
            pageSize: 25,
            qField: 'id',
          },
          fields: undefined,
          selectedActions: ['show', 'duplicate'],
        }),
    })
  )
);
var $be91cef85354cc3d$export$2e2bcd8739ae039 =
  $be91cef85354cc3d$var$useListingStore;

var $61b035b0815ca324$exports = {};
$61b035b0815ca324$exports = JSON.parse(
  '{"Indicator":"pfqcn","Application":"phpconfig","Bundle":{"app":"appBundle","current":"configBundle","security":"securityBundle"}}'
);

/**
 * @see  {@link path http://localhost:3000/dev/quality_assurance/naming-convention-pfqcn }
 * @param bui Bundle unit interface object
 * @param Part part of the doc
 * @param Element element belonging to the part of the doc
 * @returns return the fqcn as a string in the format 'pfqnc_phprconfig_appBundle_main_menu_links'
 */ const $14899fc8b120af69$export$c11f7f0cac96af2a = (bui, Part, Element) => {
  let fqcn = `${
    (0, /*@__PURE__*/ $parcel$interopDefault($61b035b0815ca324$exports))
      .Indicator
  }:${
    (0, /*@__PURE__*/ $parcel$interopDefault($61b035b0815ca324$exports))
      .Application
  }:${bui.Bundle}:${bui.Unit}:${bui.Interface}${Part ? ':' + Part : ''}${
    Element ? ':' + Element : ''
  }`;
  return fqcn;
};
/**
 * Goal: workaround Joyride not support of dot '.' and double dots ":" inside target.[since it is using css selectors]
 * Replaces the `property` value of each object in `arrayObjects` that matches the `searchValue`
 * with the `replaceValue`.
 * @param {object[]} arrayObjects - An array of objects to be modified.
 * @param {string} property - The property name to be modified in each object.
 * @returns {any[]} An array of modified values of the specified `property`.
 */ function $14899fc8b120af69$export$5ef1c346a2bc96ea(arrayObjects, property) {
  return arrayObjects.map(i => {
    // destruct i so we can have the values, not the reference copy (doing newObj=i give the reference !!)
    let newObj = {
      ...i,
    };
    newObj[property] = i[property]
      .toString()
      .replace(/[.]/g, '\\.')
      .replace(/[:]/g, '\\:');
    return newObj;
  });
}
const $14899fc8b120af69$export$6dcf99043c7108a7 = item => {
  return item.replace(/[.]/g, '\\.').replace(/[:]/g, '\\:');
};

const $7e22cf9a2c0887ea$var$DropdownFields = ({
  defaultFields: defaultFields,
  resource: resource,
  fqcn_bui: fqcn_bui,
  selectedList: selectedList,
}) => {
  const { fields: fields, setFields: setFields } = (0,
  $be91cef85354cc3d$export$2e2bcd8739ae039)();
  const [isOpen, setIsOpen] = (0, $8zHUo$react.useState)(false);
  //translate
  const { t: t } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
  //@ts-ignore
  const [selected, setSelected] = (0, $8zHUo$react.useState)(selectedList);
  const router = (0, $8zHUo$nextrouter.useRouter)();
  (0, $8zHUo$react.useEffect)(() => {
    // setSelected(selectedList)
    if (router.isReady) {
      setFields(
        router.query.fields
          ? router.query.fields.toString().split(',')
          : selectedList
      );
      setSelected(
        router.query.fields
          ? router.query.fields.toString().split(',')
          : selected //defaultFields
      );
    }
  }, [router.query]);
  return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
    (0, $8zHUo$phpcreationfrontendcomponentsreact.Dropdown),
    {
      position: 'right',
      useChevron: true,
      icon: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
        (0, $8zHUo$phpcreationfrontendcomponentsreact.IconMenu),
        {
          className: 'w-4 h-4 text-gray-500',
        }
      ),
      title: 'fields',
      id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, 'fields'),
      size: 'medium',
      children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
        className: 'flex flex-col space-y-2',
        style: {
          overflowY: defaultFields.length > 10 ? 'scroll' : 'clip',
          height: defaultFields.length > 10 ? '500px' : 'auto',
        },
        children: [
          /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('span', {
            id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
              fqcn_bui,
              'fields',
              'select-text'
            ),
            // onClick={() => console.log(fields)}
            className: 'text-xs text-gray-600 border-b pb-1 mb-2 mx-2 ',
            children: t('Selected fields'),
          }),
          /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
            className: 'text-gray-600 flex-col space-y-2 divide-y px-2',
            children: defaultFields.map(item =>
              /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
                'div',
                {
                  className: '__Row_1 flex space-x-3 items-center ',
                  children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
                      className: 'w-5 flex justify-start ',
                      children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                        (0, $8zHUo$phpcreationfrontendcomponentsreact.Input),
                        {
                          id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                            fqcn_bui,
                            'fields',
                            item.toLocaleLowerCase() + '-checkbox'
                          ),
                          checked: selected.includes(item),
                          onChange: () => {
                            if (selected?.includes(item))
                              setSelected(selected.filter(e => e !== item));
                            else setSelected([...selected, item]);
                          },
                          // size="small"
                          type: 'checkbox',
                        }
                      ),
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('span', {
                      className: 'font-medium text-gray-500 text-sm pb-1',
                      children:
                        t(item).charAt(0).toUpperCase() + t(item).slice(1),
                    }),
                  ],
                },
                defaultFields.indexOf(t(item))
              )
            ),
          }),
          /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
            className: 'w-full px-3 py-2',
            children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
              (0, $8zHUo$phpcreationfrontendcomponentsreact.Button),
              {
                style: {
                  marginTop: '10px',
                  marginBottom: '10px',
                },
                id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                  fqcn_bui,
                  'fields',
                  'apply-button'
                ),
                title: t('Apply'),
                size: 'xsmall',
                onClick: () => {
                  setFields(selected);
                  setIsOpen(false);
                },
                className: 'w-full rounded-md',
              }
            ),
          }),
        ],
      }),
    }
  );
};
var $7e22cf9a2c0887ea$export$2e2bcd8739ae039 =
  $7e22cf9a2c0887ea$var$DropdownFields;

const $3759d9f99532d93e$export$171d47c8dfe07c5a = (data, filename) => {
  const ws = $8zHUo$xlsx.utils.json_to_sheet(data);
  const wb = $8zHUo$xlsx.utils.book_new();
  $8zHUo$xlsx.utils.book_append_sheet(wb, ws, 'data');
  /* generate XLSX file and send to client */ $8zHUo$xlsx.writeFile(
    wb,
    filename + '.xlsx'
  );
};
const $3759d9f99532d93e$export$35193a8a641bb1b = (json, filename) => {
  const worksheet = $8zHUo$xlsx.utils.json_to_sheet(json);
  const workbook = {
    Sheets: {
      data: worksheet,
    },
    SheetNames: ['data'],
  };
  $8zHUo$xlsx.writeFile(workbook, filename + '.csv');
};

const $908dddbc956107bd$var$DropdownExports = ({
  fields: fields,
  resource: resource,
  fqcn_bui: fqcn_bui,
}) => {
  const { filters: filters } = (0, $be91cef85354cc3d$export$2e2bcd8739ae039)();
  const { data: data } = (0, $49eb772184ca2f2b$export$ad6724ecf32710ae)(
    resource,
    filters,
    false
  );
  //translate
  const { t: t } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
  return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
    (0, $8zHUo$phpcreationfrontendcomponentsreact.Dropdown),
    {
      position: 'left',
      useChevron: true,
      icon: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
        (0, $8zHUo$phpcreationfrontendcomponentsreact.IconGlyphExport),
        {
          fill: 'gray',
          className: 'w-4 h-4 text-blue-login',
        }
      ),
      title: t('exports'),
      size: 'xsmall',
      id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, 'exports'),
      className: 'w-full',
      children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
          fqcn_bui,
          'exports',
          'list'
        ),
        className: 'text-gray-500 flex-col p-1 space-y-2 divide-y px-2 w-full',
        children: [
          /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
            (0, $8zHUo$phpcreationfrontendcomponentsreact.Button),
            {
              size: 'xsmall',
              id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                fqcn_bui,
                'exports',
                'list:excel-link'
              ),
              className: 'w-full rounded-md',
              icon: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                (0, $8zHUo$phpcreationfrontendcomponentsreact.IconGlyphExport),
                {
                  fill: 'white',
                  className: 'w-4 h-4 text-blue-login',
                }
              ),
              onClick: () => {
                const modified_json = data.map(tn => {
                  const obj = Object.fromEntries(fields.map(f => [f, tn.f]));
                  for (const key of fields) obj[key] = tn[key];
                  return obj;
                });
                (0, $3759d9f99532d93e$export$171d47c8dfe07c5a)(
                  modified_json,
                  resource
                );
              },
              title: 'Excel',
            }
          ),
          /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
            (0, $8zHUo$phpcreationfrontendcomponentsreact.Button),
            {
              id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                fqcn_bui,
                'exports',
                'list:csv-link'
              ),
              size: 'xsmall',
              className: 'w-full rounded-md',
              icon: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                (0, $8zHUo$phpcreationfrontendcomponentsreact.IconGlyphExport),
                {
                  fill: 'white',
                  className: 'w-4 h-4 text-blue-login',
                }
              ),
              onClick: () => {
                const modified_json = data.map(tn => {
                  const obj = Object.fromEntries(fields.map(f => [f, tn.f]));
                  for (const key of fields) obj[key] = tn[key];
                  return obj;
                });
                (0, $3759d9f99532d93e$export$35193a8a641bb1b)(
                  modified_json,
                  resource
                );
              },
              title: 'CSV',
            }
          ),
        ],
      }),
    }
  );
};
var $908dddbc956107bd$export$2e2bcd8739ae039 =
  $908dddbc956107bd$var$DropdownExports;

const $d104ffa792c5b78f$var$DropdownActions = ({
  defaultActions: defaultActions,
  resource: resource,
  fqcn_bui: fqcn_bui,
}) => {
  //translate
  const { t: t } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
  const {
    selectedActions: selectedActions,
    setSelectedActions: setSelectedActions,
  } = (0, $be91cef85354cc3d$export$2e2bcd8739ae039)();
  const [actions, setActions] = (0, $8zHUo$react.useState)([]);
  const router = (0, $8zHUo$nextrouter.useRouter)();
  (0, $8zHUo$react.useEffect)(() => {
    if (router.isReady) {
      setSelectedActions(
        router.query.actions
          ? router.query.actions.toString().split(',')
          : [t('show')] // defaultActions
      );
      setActions(
        router.query.actions
          ? router.query.actions.toString().split(',')
          : [t('show')] // defaultActions
      );
    }
  }, [router.query]);
  return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
    (0, $8zHUo$phpcreationfrontendcomponentsreact.Dropdown),
    {
      id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, 'actions'),
      title: t('Actions'),
      position: 'right',
      useChevron: true,
      size: 'small',
      icon: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
        (0, $8zHUo$phpcreationfrontendcomponentsreact.IconLightning),
        {
          className: 'w-4 h-4 text-gray-500',
        }
      ),
      children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
        className: 'p-1 ',
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
          className: '__ Section_select flex flex-col space-y-1 p-1 ',
          children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('span', {
              id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                fqcn_bui,
                'actions',
                'select-text'
              ),
              className: 'text-xs text-gray-600 border-b pb-1 ',
              children: t('Selected actions'),
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
              className: 'py-1',
              children: defaultActions.map(elt =>
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
                  'div',
                  {
                    className: '__Row_1 flex space-x-3 items-center ',
                    children: [
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
                        className: 'w-5 flex justify-start ',
                        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                          (0, $8zHUo$phpcreationfrontendcomponentsreact.Input),
                          {
                            id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                              fqcn_bui,
                              'actions',
                              elt.toLocaleLowerCase() + '-checkbox'
                            ),
                            checked: actions?.includes(t(elt)),
                            onChange: () => {
                              if (actions?.includes(t(elt)))
                                setActions(actions.filter(e => e !== t(elt)));
                              else setActions([...actions, t(elt)]);
                            },
                            // size="small"
                            type: 'checkbox',
                          }
                        ),
                      }),
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('span', {
                        className:
                          'font-medium text-gray-500 text-sm pb-1 capitalize',
                        children: t(elt),
                      }),
                    ],
                  },
                  defaultActions.indexOf(elt)
                )
              ),
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
              className: ' flex justify-center bg-gray-50',
              children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                (0, $8zHUo$phpcreationfrontendcomponentsreact.Button),
                {
                  id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                    fqcn_bui,
                    'exports',
                    'apply-button'
                  ),
                  title: t('apply'),
                  size: 'xsmall',
                  onClick: () => setSelectedActions(actions),
                  className: 'w-full rounded-md',
                }
              ),
            }),
          ],
        }),
      }),
    }
  );
};
var $d104ffa792c5b78f$export$2e2bcd8739ae039 =
  $d104ffa792c5b78f$var$DropdownActions;

const $05f0bdbc2fb3ad37$var$useModalsStore = (0, $8zHUo$zustand.create)(
  (0, $8zHUo$zustandmiddleware.combine)(
    {
      modalAdd: {
        isOpen: false,
        data: null,
      },
      modalEdit: {
        isOpen: false,
        data: null,
      },
      modalDuplicate: {
        isOpen: false,
        data: null,
      },
      modalDelete: {
        isOpen: false,
        data: null,
      },
    },
    set => ({
      setModalAdd: (isOpen, data) =>
        set(s => ({
          modalAdd: {
            isOpen: isOpen,
            data: data,
          },
        })),
      setModalEdit: (isOpen, data) =>
        set(s => ({
          modalEdit: {
            isOpen: isOpen,
            data: data,
          },
        })),
      setModalDuplicate: (isOpen, data) =>
        set(s => ({
          modalDuplicate: {
            isOpen: isOpen,
            data: data,
          },
        })),
      setModalDelete: (isOpen, data) =>
        set(s => ({
          modalDelete: {
            isOpen: isOpen,
            data: data,
          },
        })),
      closeAllModals: () =>
        set({
          modalAdd: {
            isOpen: false,
            data: null,
          },
          modalEdit: {
            isOpen: false,
            data: null,
          },
          modalDelete: {
            isOpen: false,
            data: null,
          },
          modalDuplicate: {
            isOpen: false,
            data: null,
          },
        }),
    })
  )
);
var $05f0bdbc2fb3ad37$export$2e2bcd8739ae039 =
  $05f0bdbc2fb3ad37$var$useModalsStore;

//import parse from 'html-react-parser';
const $bdbe64709c52488d$var$useListingColumns = (
  resource,
  defaultColumns,
  fqcn_bui,
  untouched
) => {
  const {
    filters: filters,
    fields: fields,
    selectedActions: selectedActions,
  } = (0, $be91cef85354cc3d$export$2e2bcd8739ae039)();
  const {
    setModalDelete: setModalDelete,
    setModalEdit: setModalEdit,
    setModalDuplicate: setModalDuplicate,
  } = (0, $05f0bdbc2fb3ad37$export$2e2bcd8739ae039)();
  //translate
  const { t: t } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
  const Actions = {
    title: t('Actions'),
    dataIndex: 'actions',
    key: 'actions',
    className: 'print:hidden',
    render: (text, record) =>
      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
        id: 'button_table_actions',
        className: 'flex items-center space-x-3 justify-start max-w-32',
        children: [
          record.selectedActions.includes(t('show')) &&
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
              (0, $8zHUo$phpcreationfrontendcomponentsreact.Tooltip),
              {
                content: t('show'),
                side: 'bottom',
                delayDuration: 400,
                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
                  children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $parcel$interopDefault($8zHUo$nextlink)),
                    {
                      href: `/${resource}/${record.id}`,
                      children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                        (0, $8zHUo$phpcreationfrontendcomponentsreact.Button),
                        {
                          id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                            fqcn_bui,
                            'list',
                            'actions:show-button'
                          ),
                          size: 'xsmall',
                          icon: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                            (0,
                            $8zHUo$phpcreationfrontendcomponentsreact.IconMagnifier),
                            {
                              className: 'w-4 h-4 scale-[0.9]',
                            }
                          ),
                          onClick: () => {},
                          bgcolor: 'transparent',
                          color: 'gray-500',
                          borderWidth: '2',
                          bordercolor: 'gray-200',
                        }
                      ),
                    }
                  ),
                }),
              }
            ),
          record.selectedActions.includes(t('edit')) &&
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
              (0, $8zHUo$phpcreationfrontendcomponentsreact.Tooltip),
              {
                content: t('edit'),
                side: 'bottom',
                delayDuration: 400,
                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
                  children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.Button),
                    {
                      id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                        fqcn_bui,
                        'list',
                        'actions:edit-button'
                      ),
                      onClick: event => {
                        event.stopPropagation();
                        setModalEdit(true, record);
                      },
                      variant: 'neutral',
                      size: 'xsmall',
                      icon: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                        (0, $8zHUo$phpcreationfrontendcomponentsreact.IconEdit),
                        {
                          className: 'w-4 h-4 scale-[0.9] ',
                        }
                      ),
                    }
                  ),
                }),
              }
            ),
          record.selectedActions.includes(t('duplicate')) &&
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
              (0, $8zHUo$phpcreationfrontendcomponentsreact.Tooltip),
              {
                content: t('duplicate'),
                side: 'bottom',
                delayDuration: 400,
                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
                  children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.Button),
                    {
                      id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                        fqcn_bui,
                        'list',
                        'actions:duplicate-button'
                      ),
                      onClick: event => {
                        event.stopPropagation();
                        setModalDuplicate(true, record);
                      },
                      variant: 'neutral',
                      bgcolor: 'gray-100',
                      color: 'gray-500',
                      size: 'xsmall',
                      icon: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                        (0,
                        $8zHUo$phpcreationfrontendcomponentsreact.IconDuplicate),
                        {
                          className: 'w-4 h-4 scale-[0.9] hover:text-blue-600',
                        }
                      ),
                    }
                  ),
                }),
              }
            ),
          record.selectedActions.includes(t('delete')) &&
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
              (0, $8zHUo$phpcreationfrontendcomponentsreact.Tooltip),
              {
                content: t('delete'),
                side: 'bottom',
                delayDuration: 400,
                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
                  children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.Button),
                    {
                      id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                        fqcn_bui,
                        'list',
                        'actions:delete-button'
                      ),
                      onClick: event => {
                        event.stopPropagation();
                        setModalDelete(true, record);
                      },
                      variant: 'urgent',
                      size: 'xsmall',
                      icon: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                        (0,
                        $8zHUo$phpcreationfrontendcomponentsreact.IconTrash),
                        {
                          className: 'w-4 h-4 scale-[0.9] ',
                        }
                      ),
                    }
                  ),
                }),
              }
            ),
          record.selectedActions.includes(t('close')) &&
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
              (0, $8zHUo$phpcreationfrontendcomponentsreact.Tooltip),
              {
                content: t('close'),
                side: 'bottom',
                delayDuration: 400,
                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
                  children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.Button),
                    {
                      id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                        fqcn_bui,
                        'list',
                        'actions:edit-button'
                      ),
                      onClick: event => {
                        event.stopPropagation();
                        setModalEdit(true, record);
                      },
                      variant: 'neutral',
                      size: 'xsmall',
                      icon: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                        (0,
                        $8zHUo$phpcreationfrontendcomponentsreact.IconClose),
                        {
                          className:
                            'w-4 h-4 scale-[0.9] text-gray-400 hover:text-blue-600',
                        }
                      ),
                    }
                  ),
                }),
              }
            ),
        ],
      }),
  };
  const [Columns, setColumns] = (0, $8zHUo$react.useState)([]);
  (0, $8zHUo$react.useEffect)(() => {
    let array_fields = defaultColumns.map(item => {
      return {
        title: t(item.title),
        dataIndex: item.key,
        sorter: item.sortable ? item.sortable : false,
        render: item.render
          ? console.log() //   ? (text: any, record: any) =>
          : //   item.type == 'url' ? (
            //     <Link
            //       href={`/${
            //         item.key.split('.').length > 1
            //           ? item.key.split('.')[0] + 's'
            //           : resource
            //       }/${_.get(record, item.key)}`}
            //     >
            //       <a id={getFQCN(fqcn_bui, 'list', item.key + '-link')}>
            //         {_.get(record, item.key)}
            //       </a>
            //     </Link>
            //   ) : (
            //     <span
            //       id={getFQCN(fqcn_bui, 'list', item.key + '-text')}
            //       onClick={() => {
            //         console.log('record=', record);
            //       }}
            //     >
            //       {parse(_.get(record, item.key))}
            //     </span>
            //   )
            (text, record) =>
              item.type == 'url'
                ? /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $parcel$interopDefault($8zHUo$nextlink)),
                    {
                      href: `/${
                        item.key.split('.').length > 1
                          ? item.title //item.key.split('.')[0] + 's'
                          : resource
                      }/${
                        item.key.split('.').length > 1
                          ? (0, $parcel$interopDefault($8zHUo$lodash)).get(
                              record,
                              item.link
                            )
                          : (0, $parcel$interopDefault($8zHUo$lodash)).get(
                              record,
                              item.key
                            )
                      }`,
                      children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                        'a',
                        {
                          id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                            fqcn_bui,
                            'list',
                            item.key + '-link'
                          ),
                          children: (0,
                          $parcel$interopDefault($8zHUo$lodash)).get(
                            record,
                            item.key
                          ),
                        }
                      ),
                    }
                  ) // item.type == 'url' ?
                : // <Link
                // href={`/${resource}/${_.get(record, item.key)}`}
                // >
                // <a id={getFQCN(fqcn_bui, 'list', item.key + '-link')}>
                //   {_.get(record, item.key)}
                // </a>
                // </Link>
                //       :
                //       (text: any, record: any) => item.type == 'url' && item.link != '' ? (
                //       <Link
                //         href={`/${item.title}/${_.get(record, item.link!)}`}
                //       >
                //       {/*  <Link
                //          href={`/${
                //            item.key.split('.').length > 1
                //              ? item.title  //item.key.split('.')[0] + 's'
                //              : resource
                //          }/${item.key.split('.').length > 1 ?
                //           _.get(record, item.link!) :
                //           _.get(record, item.key)}`}
                //        >*/}
                //         <a id={getFQCN(fqcn_bui, 'list', item.key + '-link')}>
                //           {_.get(record, item.key)}
                //         </a>
                //       </Link>
                item.type == 'boolean' //   <Link
                ? //   href={`/${
                  //     item.key.split('.').length > 1
                  //       ? item.title  //item.key.split('.')[0] + 's'
                  //       : resource
                  //   }/${item.key.split('.').length > 1 ? _.get(record, item.link!) : _.get(record, item.key)}`}
                  // >
                  //   <a id={getFQCN(fqcn_bui, 'list', item.key + '-link')}>
                  (0, $parcel$interopDefault($8zHUo$lodash)).get(
                    record,
                    item.key
                  ) // </a>
                : // </Link>
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('span', {
                    id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                      fqcn_bui,
                      'list',
                      item.key + '-text'
                    ),
                    children: (0,
                    $parcel$interopDefault($8zHUo$htmlreactparser))(
                      (0, $parcel$interopDefault($8zHUo$lodash)).get(
                        record,
                        item.key
                      )
                    ),
                  }),
      };
    }); //@ts-ignore //this .concat([Actions]) was here
    // reflect columns selction
    const array_fields_selected = array_fields.filter(i => {
      i.title = i.title.charAt(0).toUpperCase() + i.title.slice(1);
      return fields?.includes(i.dataIndex.split('.')[0]);
    });
    setColumns(untouched ? array_fields : array_fields_selected);
  }, [fields]);
  if (fields == undefined) return Columns;
  else if (selectedActions.length == 0) return Columns;
  else return Columns.concat([Actions]);
};
var $bdbe64709c52488d$export$2e2bcd8739ae039 =
  $bdbe64709c52488d$var$useListingColumns;

const $c092319464fa2356$var$TableListing = ({
  resource: resource,
  defaultColumns: defaultColumns,
  fqcn_bui: fqcn_bui,
  id: id,
}) => {
  const { closeAllModals: closeAllModals } = (0,
  $05f0bdbc2fb3ad37$export$2e2bcd8739ae039)();
  const {
    fields: fields,
    filters: filters,
    selectedActions: selectedActions,
    setSort: setSort,
    setOrder: setOrder,
    setPageSize: setPageSize,
    setPage: setPage,
  } = (0, $be91cef85354cc3d$export$2e2bcd8739ae039)();
  const {
    isLoading: issLoading,
    isError: isError,
    isSuccess: isSuccess,
    data: data,
    refetch: refetch,
  } = (0, $49eb772184ca2f2b$export$ad6724ecf32710ae)(resource, filters, true);
  const queryClient = (0, $8zHUo$tanstackreactquery.useQueryClient)();
  const {
    isLoading: isLoadingCreate,
    isError: isErrorCreate,
    isSuccess: isSuccessCreate,
    data: DataCreate,
    mutate: create_,
  } = (0, $49eb772184ca2f2b$export$5edc9d665968dd86)(resource);
  const {
    isLoading: isLoadingUpdate,
    isError: isErrorUpdate,
    isSuccess: isSuccessUpdate,
    data: DataUpdate,
    mutate: update_,
  } = (0, $49eb772184ca2f2b$export$74524c73191a667c)(resource);
  const {
    isLoading: isLoadingDelete,
    isError: isErrorDelete,
    isSuccess: isSuccessDelete,
    data: DataDelete,
    mutate: delete_,
  } = (0, $49eb772184ca2f2b$export$60acb8fd13afd60d)(resource);
  const ismutating = (0, $8zHUo$tanstackreactquery.useIsMutating)();
  const router = (0, $8zHUo$nextrouter.useRouter)();
  (0, $8zHUo$react.useEffect)(() => {
    const TO = setTimeout(() => {
      closeAllModals();
    }, 600);
    return () => clearTimeout(TO);
  }, [ismutating]);
  // useEffect(() => {
  //    console.log('hello', ismutating);
  // }, [ismutating]);
  return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
    className: '',
    style: {
      maxWidth: issLoading ? 'auto' : screen.width < 600 ? '100%' : 'auto',
    },
    id: id,
    children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
      (0, $8zHUo$phpcreationfrontendcomponentsreact.Table),
      {
        rowClassName: 'cursor-pointer',
        style: {
          maxWidth: issLoading ? 'auto' : screen.width < 600 ? '100%' : 'auto',
        },
        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, 'list'),
        rowKey: 'id',
        onRow: (record, rowIndex) => {
          return {
            onClick: event => {
              const target = event.target;
              const isLink = target.tagName === 'A' || target.closest('a');
              if (!isLink) {
                if (event.ctrlKey)
                  window.open('/' + resource + '/' + record.id, '_blank');
                else router.push('/' + resource + '/' + record.id);
              }
            },
          };
        },
        columns: (0, $bdbe64709c52488d$export$2e2bcd8739ae039)(
          resource,
          defaultColumns,
          fqcn_bui
        ),
        // columns={useListingColumns(resource).filter(col =>
        //   fields?.includes(col.key)
        // )}
        loading:
          isLoadingCreate ||
          issLoading ||
          isLoadingDelete ||
          isLoadingUpdate ||
          ismutating == 1,
        dataSource: data
          ? [
              ...data['hydra:member'].map(e => ({
                ...e,
                selectedActions: selectedActions,
              })),
            ]
          : [],
        onChange: (pagination, filters, sorter) => {
          setPage(pagination.current);
          setPageSize(pagination.pageSize ? pagination.pageSize : 10);
          if (sorter.hasOwnProperty('column')) {
            //TODO: fix types
            //@ts-ignore
            if (sorter.order === 'ascend') {
              //@ts-ignore
              setSort(sorter.field);
              setOrder('asc');
            }
            //@ts-ignore
            if (sorter.order === 'descend') {
              //@ts-ignore
              setSort(sorter.field);
              setOrder('desc');
            }
            //@ts-ignore
            if (sorter.order == undefined) {
              setSort(undefined);
              setOrder(undefined);
            }
          }
        },
        pagination: {
          pageSize: filters.pageSize ? filters.pageSize : 25,
          current: filters.page ? filters.page : 1,
          showSizeChanger: true,
          total: data && data['hydra:totalItems'],
          pageSizeOptions: [5, 25, 100, 500, 1000],
          position: ['bottomRight'],
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} items`,
        },
        scroll: {
          x: true,
        },
      }
    ),
  });
};
var $c092319464fa2356$export$2e2bcd8739ae039 =
  $c092319464fa2356$var$TableListing;

const $1a0d490a6687c933$var$ModalAdd = ({
  resource: resource,
  formInputs: formInputs,
}) => {
  const {
    isLoading: isLoadingCreateResource,
    isError: isErrorCreateResource,
    isSuccess: isSuccessCreateResource,
    data: DataCreateResource,
    mutate: create_resource,
  } = (0, $49eb772184ca2f2b$export$5edc9d665968dd86)(resource);
  const { modalAdd: modalAdd, setModalAdd: setModalAdd } = (0,
  $05f0bdbc2fb3ad37$export$2e2bcd8739ae039)();
  const [FormData, setFormData] = (0, $8zHUo$react.useState)({});
  const [check, setCheck] = (0, $8zHUo$react.useState)(false);
  //translate
  const { t: t } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
  return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
    (0, $8zHUo$phpcreationfrontendcomponentsreact.Modal),
    {
      title: t('Add ') + t(resource.toString().slice(0, resource.length - 1)),
      isOpen: modalAdd.isOpen,
      handleClose: () => {
        setModalAdd(false), setFormData({});
      },
      isButtonOkLoading: isLoadingCreateResource,
      hanldleOK: () => {
        let adjusted_formData = (0, $64fb6a6b423817c8$export$5ea1bdf6a9d3779f)(
          FormData,
          formInputs
        );
        //@ts-ignore
        create_resource(adjusted_formData);
        setFormData({});
      },
      handleCancel: () => {
        setModalAdd(false), setFormData({});
      },
      children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
        className: 'flex flex-col items-start space-y-1',
        children: formInputs.map((field, index) => {
          if (field.type == 'text')
            return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
              'div',
              {
                className: 'flex flex-col items-start gap-1 text-sm',
                children: [
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                    children: t(field.label),
                  }),
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.TextArea),
                    {
                      // size="large"
                      onChange: e =>
                        setFormData({
                          ...FormData,
                          [field.name]: e.target.value,
                        }),
                      value: FormData[field.name] ?? '',
                      placeholder: `${t(field.placeholder ?? '')}`,
                      size: 'small',
                    }
                  ),
                ],
              },
              index
            );
          else if (field.type == 'email')
            return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
              'div',
              {
                className: 'flex flex-col items-start gap-1 text-sm',
                children: [
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                    children: t(field.label),
                  }),
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.Input),
                    {
                      type: 'email',
                      pattern: '[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$',
                      required: true,
                      // size="large"
                      onChange: e =>
                        setFormData({
                          ...FormData,
                          [field.name]: e.target.value,
                        }),
                      value: FormData[field.name] ?? '',
                      placeholder: `${t(field.placeholder ?? '')}`,
                    }
                  ),
                ],
              },
              index
            );
          else if (field.type == 'phone')
            return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
              'div',
              {
                className: 'flex flex-col items-start gap-1 text-sm',
                children: [
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                    children: t(field.label),
                  }),
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.Input),
                    {
                      type: 'phone',
                      pattern: '[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$',
                      required: true,
                      // size="large"
                      onChange: e =>
                        setFormData({
                          ...FormData,
                          [field.name]: e.target.value,
                        }),
                      value: FormData[field.name] ?? '',
                      placeholder: `${t(field.placeholder ?? '')}`,
                    }
                  ),
                ],
              },
              index
            );
          else if (field.type == 'number')
            return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
              'div',
              {
                className: 'flex flex-col items-start gap-1 text-sm',
                children: [
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                    children: t(field.label),
                  }),
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.Input),
                    {
                      type: 'number',
                      // size="large"
                      onChange: e =>
                        setFormData({
                          ...FormData,
                          [field.name]: parseInt(e.target.value),
                        }),
                      value: FormData[field.name] ?? '',
                      placeholder: `${t(field.placeholder ?? '')}`,
                    }
                  ),
                ],
              },
              index
            );
          else if (field.type == 'date')
            return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
              'div',
              {
                className: 'flex flex-col items-start gap-1 text-sm',
                children: [
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                    children: t(field.label),
                  }),
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.Input),
                    {
                      type: 'date',
                      // size="large"
                      onChange: e =>
                        setFormData({
                          ...FormData,
                          [field.name]: e.target.value,
                        }),
                      value: FormData[field.name] ?? '',
                      placeholder: `${t(field.placeholder ?? '')}`,
                    }
                  ),
                ],
              },
              index
            );
          else if (field.type == 'select')
            return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
              'div',
              {
                className: 'flex flex-col items-start -space-y-0 gap-1 text-sm',
                children: [
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                    children: t(field.name),
                  }),
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.Select),
                    {
                      placeholder: t(
                        field.placeholder ? field.placeholder : ''
                      ),
                      options: field.optionsArrayFinite,
                      onChange: newIds => {
                        setFormData({
                          ...FormData,
                          [field.name]: newIds,
                        });
                      },
                      // label={ FormData[field.name]}
                      value: FormData[field.name],
                    }
                  ),
                ],
              },
              index
            );
          else if (field.type == 'select_multi' && field.isMulti == true)
            return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
              'div',
              {
                className: 'flex flex-col items-start -space-y-0 gap-1 text-sm',
                children: [
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                    children: t(field.name),
                  }),
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.Select),
                    {
                      isMulti: true,
                      placeholder: t(
                        field.placeholder ? field.placeholder : ''
                      ),
                      options: field.optionsArrayFinite,
                      defaultOptions: true,
                      cacheOptions: true,
                      onChange: newIds => {
                        setFormData({
                          ...FormData,
                          [field.name]: newIds,
                        });
                      },
                      // label={ FormData[field.name]}
                      value: FormData[field.name],
                    }
                  ),
                ],
              },
              index
            );
          else if (field.type == 'checkbox')
            return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
              className: 'flex flex-col items-start -space-y-0 gap-1 text-sm',
              children: [
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                  children: t(field.name),
                }),
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                  (0, $8zHUo$phpcreationfrontendcomponentsreact.Toggle),
                  {
                    style: {
                      backgroundColor: check == true ? 'blue' : 'red',
                    },
                    checkedChildren: 'True',
                    unCheckedChildren: 'False',
                    onChange: newIds => {
                      setFormData({
                        ...FormData,
                        [field.name]: newIds,
                      });
                      setCheck(newIds);
                    },
                    checked: FormData[field.name],
                  },
                  FormData[field.name]
                ),
              ],
            });
          else if (field.type == 'select_async')
            return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
              'div',
              {
                className: 'flex flex-col items-start -space-y-0 gap-1 text-sm',
                children: [
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                    children: t(field.label),
                  }),
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.Select),
                    {
                      variant: 'async',
                      placeholder: field.placeholder,
                      defaultOptions: true,
                      cacheOptions: true,
                      loadOptions: (input, callback) => {
                        (0, $686ab0e2fb05f109$export$6079a388768cd3b7)(
                          `${field.targetResourceAsync}`,
                          {
                            id: input,
                          },
                          false
                        )
                          .then(res =>
                            res.map(i => {
                              return {
                                label: field.resourceAsyncLabelParam
                                  ? (0,
                                    $parcel$interopDefault(
                                      $8zHUo$htmlreactparser
                                    ))(i[field.resourceAsyncLabelParam])
                                  : i.id,
                                value: i.id,
                              };
                            })
                          )
                          .then(data => callback(data));
                      },
                      onChange: newIds => {
                        setFormData({
                          ...FormData,
                          [field.name]: newIds,
                        });
                      },
                      value: FormData[field.name],
                    }
                  ),
                ],
              },
              index
            );
          else if (field.type === 'input')
            return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
              'div',
              {
                className: 'flex flex-col items-start gap-1 text-sm',
                children: [
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                    children: t(field.label),
                  }),
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.Input),
                    {
                      required: true,
                      // size="large"
                      onChange: e =>
                        setFormData({
                          ...FormData,
                          [field.name]: e.target.value,
                        }),
                      value: FormData[field.name] ?? '',
                      placeholder: `${t(field.placeholder ?? '')}`,
                    }
                  ),
                ],
              },
              index
            );
        }),
      }),
    }
  );
};
var $1a0d490a6687c933$export$2e2bcd8739ae039 = $1a0d490a6687c933$var$ModalAdd;

const $830a7a2235425dde$var$ModalDelete = ({ resource: resource }) => {
  const { modalDelete: modalDelete, setModalDelete: setModalDelete } = (0,
  $05f0bdbc2fb3ad37$export$2e2bcd8739ae039)();
  const {
    isLoading: isLoadingDeleteParameter,
    isError: isErrorDeleteParameter,
    isSuccess: isSuccessDeleteParameter,
    data: DataDeleteParameter,
    mutate: delete_parameter,
  } = (0, $49eb772184ca2f2b$export$60acb8fd13afd60d)(resource);
  //translate
  const { t: t } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
  return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
    (0, $8zHUo$phpcreationfrontendcomponentsreact.Modal),
    {
      title:
        t('Delete ') + t(resource.toString().slice(0, resource.length - 1)),
      isDanger: true,
      isOpen: modalDelete.isOpen,
      handleClose: () => setModalDelete(false, null),
      isButtonOkLoading: isLoadingDeleteParameter,
      hanldleOK: () => {
        delete_parameter(modalDelete.data.id);
      },
      handleCancel: () => setModalDelete(false, null),
      children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
        className: 'flex flex-col space-y-3',
        children: [
          /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('p', {
            children: [
              t('Do you really want to delete this'),
              ' ',
              t(resource.toString().slice(0, resource.length - 1)),
              ' ?',
            ],
          }),
          /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {}),
          /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
            children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('span', {
              children: [
                'ID : ',
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('b', {
                  children: modalDelete.data?.id,
                }),
              ],
            }),
          }),
        ],
      }),
    }
  );
};
var $830a7a2235425dde$export$2e2bcd8739ae039 =
  $830a7a2235425dde$var$ModalDelete;

const $ca6474ef28c3aa2a$var$ModalDuplicate = ({
  resource: resource,
  formInputs: formInputs,
}) => {
  const {
    isLoading: isLoadingUpdate,
    isError: isErrorUpdate,
    isSuccess: isSuccessUpdate,
    data: DataUpdate,
    mutate: duplicate_resource,
  } = (0, $49eb772184ca2f2b$export$5edc9d665968dd86)(resource);
  const {
    modalDuplicate: modalDuplicate,
    setModalDuplicate: setModalDuplicate,
  } = (0, $05f0bdbc2fb3ad37$export$2e2bcd8739ae039)();
  const [FormData, setFormData] = (0, $8zHUo$react.useState)({});
  const [check, setCheck] = (0, $8zHUo$react.useState)(false);
  (0, $8zHUo$react.useEffect)(() => {
    if (modalDuplicate.data) {
      let key_value_formData = {};
      formInputs.forEach(async i => {
        if (i.type == 'text')
          //@ts-ignore
          key_value_formData[i.name] = _.get(modalDuplicate.data, i.name); //@ts-ignore
        if (i.type == 'select_async') {
          //@ts-ignore
          key_value_formData[i.name] = {
            label: '',
            //@ts-ignore
            value: _.get(modalDuplicate.data, i.name).id,
          };
          const resource = await (0, $686ab0e2fb05f109$export$7d1eefcddaeba55b)(
            `${i.targetResourceAsync}`, //@ts-ignore
            _.get(modalDuplicate.data, i.name).id
          );
          //@ts-ignore
          key_value_formData[i.name].label = i.resourceAsyncLabelParam
            ? (0, $parcel$interopDefault($8zHUo$htmlreactparser))(
                resource[i.resourceAsyncLabelParam]
              )
            : _.get(modalDuplicate.data, i.name).id;
        }
      });
      setFormData(key_value_formData);
    }
  }, [modalDuplicate]);
  //translate
  const { t: t } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
  return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
    (0, $8zHUo$phpcreationfrontendcomponentsreact.Modal),
    {
      title:
        t('Duplicate ') + t(resource.toString().slice(0, resource.length - 1)),
      isOpen: modalDuplicate.isOpen,
      handleClose: () => setModalDuplicate(false, null),
      isButtonOkLoading: isLoadingUpdate,
      hanldleOK: () => {
        let adjusted_formData = (0, $64fb6a6b423817c8$export$5ea1bdf6a9d3779f)(
          FormData,
          formInputs
        );
        //@ts-ignore
        duplicate_resource(adjusted_formData);
      },
      handleCancel: () => setModalDuplicate(false),
      children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
        className: 'flex flex-col items-start space-y-1',
        children: formInputs.map((field, index) => {
          if (field.type == 'input')
            return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
              'div',
              {
                className: 'flex flex-col items-start -space-y-2 text-sm',
                children: [
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                    children: t(field.label),
                  }),
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.Input),
                    {
                      // size="large"
                      onChange: e =>
                        setFormData({
                          ...FormData,
                          [field.name]: e.target.value,
                        }),
                      value: FormData[field.name] ?? '',
                      placeholder: `${t(field.placeholder ?? '')}`,
                    }
                  ),
                ],
              },
              index
            );
          if (field.type == 'text')
            return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
              'div',
              {
                className: 'flex flex-col items-start -space-y-2 text-sm',
                children: [
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                    children: t(field.label),
                  }),
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.TextArea),
                    {
                      // size="large"
                      onChange: e =>
                        setFormData({
                          ...FormData,
                          [field.name]: e.target.value,
                        }),
                      value: FormData[field.name] ?? '',
                      placeholder: `${t(field.placeholder ?? '')}`,
                      size: 'small',
                    }
                  ),
                ],
              },
              index
            );
          if (field.type == 'email')
            return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
              'div',
              {
                className: 'flex flex-col items-start -space-y-2 text-sm',
                children: [
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                    children: t(field.label),
                  }),
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.Input),
                    {
                      type: 'email',
                      pattern: '[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$',
                      required: true,
                      // size="large"
                      onChange: e =>
                        setFormData({
                          ...FormData,
                          [field.name]: e.target.value,
                        }),
                      value: FormData[field.name] ?? '',
                      placeholder: `${t(field.placeholder ?? '')}`,
                    }
                  ),
                ],
              },
              index
            );
          if (field.type == 'phone')
            return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
              'div',
              {
                className: 'flex flex-col items-start -space-y-2 text-sm',
                children: [
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                    children: t(field.label),
                  }),
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.Input),
                    {
                      type: 'phone',
                      pattern: '[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$',
                      required: true,
                      // size="large"
                      onChange: e =>
                        setFormData({
                          ...FormData,
                          [field.name]: e.target.value,
                        }),
                      value: FormData[field.name] ?? '',
                      placeholder: `${t(field.placeholder ?? '')}`,
                    }
                  ),
                ],
              },
              index
            );
          if (field.type == 'number')
            return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
              'div',
              {
                className: 'flex flex-col items-start -space-y-2 text-sm',
                children: [
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                    children: t(field.label),
                  }),
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.Input),
                    {
                      type: 'number',
                      // size="large"
                      onChange: e =>
                        setFormData({
                          ...FormData,
                          [field.name]: parseInt(e.target.value),
                        }),
                      value: FormData[field.name] ?? '',
                      placeholder: `${t(field.placeholder ?? '')}`,
                    }
                  ),
                ],
              },
              index
            );
          else if (field.type == 'date')
            return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
              'div',
              {
                className: 'flex flex-col items-start -space-y-2 text-sm',
                children: [
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                    children: t(field.label),
                  }),
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.Input),
                    {
                      type: 'date',
                      // size="large"
                      onChange: e =>
                        setFormData({
                          ...FormData,
                          [field.name]: e.target.value,
                        }),
                      value: FormData[field.name] ?? '',
                      placeholder: `${t(field.placeholder ?? '')}`,
                    }
                  ),
                ],
              },
              index
            );
          else if (field.type == 'select')
            return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
              'div',
              {
                className: 'flex flex-col items-start -space-y-0 text-sm',
                children: [
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                    children: t(field.name),
                  }),
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.Select),
                    {
                      placeholder: t(
                        field.placeholder ? field.placeholder : ''
                      ),
                      options: field.optionsArrayFinite,
                      onChange: newIds => {
                        setFormData({
                          ...FormData,
                          [field.name]: newIds,
                        });
                      },
                      // label={ FormData[field.name]}
                      value: FormData[field.name],
                    }
                  ),
                ],
              },
              index
            );
          // CASE Finite + Boolean
          if (field.type == 'checkbox')
            return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
              className: 'flex flex-col items-start -space-y-0 text-sm',
              children: [
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                  children: t(field.name),
                }),
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                  (0, $8zHUo$phpcreationfrontendcomponentsreact.Toggle),
                  {
                    style: {
                      backgroundColor: check == true ? 'blue' : 'red',
                    },
                    checkedChildren: 'True',
                    unCheckedChildren: 'False',
                    onChange: newIds => {
                      setFormData({
                        ...FormData,
                        [field.name]: newIds,
                      });
                      setCheck(newIds);
                    },
                    checked: FormData[field.name],
                  },
                  FormData[field.name]
                ),
              ],
            });
          else
            return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
              'div',
              {
                className: 'flex flex-col items-start -space-y-0 text-sm',
                children: [
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                    children: t(field.label),
                  }),
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.Select),
                    {
                      variant: 'async',
                      placeholder: field.placeholder,
                      defaultOptions: true,
                      cacheOptions: true,
                      loadOptions: (input, callback) => {
                        (0, $686ab0e2fb05f109$export$6079a388768cd3b7)(
                          `${field.targetResourceAsync}`,
                          {
                            id: input,
                          },
                          false
                        )
                          .then(res =>
                            res.map(i => {
                              return {
                                label: field.resourceAsyncLabelParam
                                  ? (0,
                                    $parcel$interopDefault(
                                      $8zHUo$htmlreactparser
                                    ))(i[field.resourceAsyncLabelParam])
                                  : i.id,
                                value: i.id,
                              };
                            })
                          )
                          .then(data => callback(data));
                      },
                      onChange: newIds => {
                        setFormData({
                          ...FormData,
                          [field.name]: newIds,
                        });
                      },
                      value: FormData[field.name],
                    }
                  ),
                ],
              },
              index
            );
        }),
      }),
    }
  );
};
var $ca6474ef28c3aa2a$export$2e2bcd8739ae039 =
  $ca6474ef28c3aa2a$var$ModalDuplicate;

const $3edc61f4d5704cda$var$ModalEdit = ({
  resource: resource,
  formInputs: formInputs,
}) => {
  const {
    isLoading: isLoadingUpdate,
    isError: isErrorUpdate,
    isSuccess: isSuccessUpdate,
    data: DataUpdate,
    mutate: update_resource,
  } = (0, $49eb772184ca2f2b$export$74524c73191a667c)(resource);
  const { modalEdit: modalEdit, setModalEdit: setModalEdit } = (0,
  $05f0bdbc2fb3ad37$export$2e2bcd8739ae039)();
  const [FormData, setFormData] = (0, $8zHUo$react.useState)({});
  const [check, setCheck] = (0, $8zHUo$react.useState)(false);
  (0, $8zHUo$react.useEffect)(() => {
    if (modalEdit.data) {
      let key_value_formData = {};
      formInputs.forEach(async i => {
        if (i.type == 'text')
          //@ts-ignore
          key_value_formData[i.name] = _.get(modalEdit.data, i.name); //@ts-ignore
        if (i.type == 'input')
          //@ts-ignore
          key_value_formData[i.name] = _.get(modalEdit.data, i.name); //@ts-ignore
        if (i.type == 'select_async') {
          //@ts-ignore
          key_value_formData[i.name] = {
            label: '',
            //@ts-ignore
            value: _.get(modalEdit.data, i.name).id,
          };
          const resource = await (0, $686ab0e2fb05f109$export$7d1eefcddaeba55b)(
            `${i.targetResourceAsync}`, //@ts-ignore
            _.get(modalEdit.data, i.name).id
          );
          //@ts-ignore
          key_value_formData[i.name].label = i.resourceAsyncLabelParam
            ? (0, $parcel$interopDefault($8zHUo$htmlreactparser))(
                resource[i.resourceAsyncLabelParam]
              )
            : _.get(modalEdit.data, i.name).id;
        }
      });
      setFormData(key_value_formData);
    }
  }, [modalEdit]);
  //translate
  const { t: t } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
  return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
    (0, $8zHUo$phpcreationfrontendcomponentsreact.Modal),
    {
      title: t('Edit ') + t(resource.toString().slice(0, resource.length - 1)),
      isOpen: modalEdit.isOpen,
      handleClose: () => setModalEdit(false, null),
      isButtonOkLoading: isLoadingUpdate,
      hanldleOK: () => {
        let adjusted_formData = (0, $64fb6a6b423817c8$export$5ea1bdf6a9d3779f)(
          FormData,
          formInputs
        );
        //@ts-ignore
        update_resource({
          id: modalEdit.data.id,
          ...adjusted_formData,
        });
      },
      handleCancel: () => setModalEdit(false),
      children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
        className: 'flex flex-col items-start space-y-1',
        children: formInputs.map((field, index) => {
          if (field.type == 'input')
            return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
              'div',
              {
                className: 'flex flex-col items-start -space-y-2 text-sm',
                children: [
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                    children: t(field.label),
                  }),
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.Input),
                    {
                      // size="large"
                      onChange: e =>
                        setFormData({
                          ...FormData,
                          [field.name]: e.target.value,
                        }),
                      value: FormData[field.name] ?? '',
                      placeholder: `${t(field.placeholder ?? '')}`,
                    }
                  ),
                ],
              },
              index
            );
          if (field.type == 'email')
            return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
              'div',
              {
                className: 'flex flex-col items-start -space-y-2 text-sm',
                children: [
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                    children: t(field.label),
                  }),
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.Input),
                    {
                      type: 'email',
                      pattern: '[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$',
                      required: true,
                      // size="large"
                      onChange: e =>
                        setFormData({
                          ...FormData,
                          [field.name]: e.target.value,
                        }),
                      value: FormData[field.name] ?? '',
                      placeholder: `${t(field.placeholder ?? '')}`,
                    }
                  ),
                ],
              },
              index
            );
          if (field.type == 'phone')
            return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
              'div',
              {
                className: 'flex flex-col items-start -space-y-2 text-sm',
                children: [
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                    children: t(field.label),
                  }),
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.Input),
                    {
                      type: 'phone',
                      pattern: '[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$',
                      required: true,
                      // size="large"
                      onChange: e =>
                        setFormData({
                          ...FormData,
                          [field.name]: e.target.value,
                        }),
                      value: FormData[field.name] ?? '',
                      placeholder: `${t(field.placeholder ?? '')}`,
                    }
                  ),
                ],
              },
              index
            );
          if (field.type == 'number')
            return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
              'div',
              {
                className: 'flex flex-col items-start -space-y-2 text-sm',
                children: [
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                    children: t(field.label),
                  }),
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.Input),
                    {
                      type: 'number',
                      // size="large"
                      onChange: e =>
                        setFormData({
                          ...FormData,
                          [field.name]: parseInt(e.target.value),
                        }),
                      value: FormData[field.name] ?? '',
                      placeholder: `${t(field.placeholder ?? '')}`,
                    }
                  ),
                ],
              },
              index
            );
          else if (field.type == 'date')
            return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
              'div',
              {
                className: 'flex flex-col items-start -space-y-2 text-sm',
                children: [
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                    children: t(field.label),
                  }),
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.Input),
                    {
                      type: 'date',
                      // size="large"
                      onChange: e =>
                        setFormData({
                          ...FormData,
                          [field.name]: e.target.value,
                        }),
                      value: FormData[field.name] ?? '',
                      placeholder: `${t(field.placeholder ?? '')}`,
                    }
                  ),
                ],
              },
              index
            );
          else if (field.type == 'select')
            return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
              'div',
              {
                className: 'flex flex-col items-start -space-y-0 text-sm',
                children: [
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                    children: t(field.name),
                  }),
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.Select),
                    {
                      placeholder: t(
                        field.placeholder ? field.placeholder : ''
                      ),
                      options: field.optionsArrayFinite,
                      onChange: newIds => {
                        setFormData({
                          ...FormData,
                          [field.name]: newIds,
                        });
                      },
                      // label={ FormData[field.name]}
                      value: FormData[field.name],
                    }
                  ),
                ],
              },
              index
            );
          else if (field.type == 'checkbox')
            return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
              className: 'flex flex-col items-start -space-y-0 text-sm',
              children: [
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                  children: t(field.name),
                }),
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                  (0, $8zHUo$phpcreationfrontendcomponentsreact.Toggle),
                  {
                    style: {
                      backgroundColor: check == true ? 'blue' : 'red',
                    },
                    checkedChildren: 'True',
                    unCheckedChildren: 'False',
                    onChange: newIds => {
                      setFormData({
                        ...FormData,
                        [field.name]: newIds,
                      });
                      setCheck(newIds);
                    },
                    checked: FormData[field.name],
                  },
                  FormData[field.name]
                ),
              ],
            });
          else if (field.type == 'select_async')
            return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
              'div',
              {
                className: 'flex flex-col items-start -space-y-0 text-sm',
                children: [
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                    children: t(field.label),
                  }),
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.Select),
                    {
                      variant: 'async',
                      placeholder: field.placeholder,
                      defaultOptions: true,
                      cacheOptions: true,
                      loadOptions: (input, callback) => {
                        (0, $686ab0e2fb05f109$export$6079a388768cd3b7)(
                          `${field.targetResourceAsync}`,
                          {
                            id: input,
                          },
                          false
                        )
                          .then(res =>
                            res.map(i => {
                              return {
                                label: field.resourceAsyncLabelParam
                                  ? (0,
                                    $parcel$interopDefault(
                                      $8zHUo$htmlreactparser
                                    ))(i[field.resourceAsyncLabelParam])
                                  : i.id,
                                value: i.id,
                              };
                            })
                          )
                          .then(data => callback(data));
                      },
                      onChange: newIds => {
                        setFormData({
                          ...FormData,
                          [field.name]: newIds,
                        });
                      },
                      value: FormData[field.name],
                    }
                  ),
                ],
              },
              index
            );
        }),
      }),
    }
  );
};
var $3edc61f4d5704cda$export$2e2bcd8739ae039 = $3edc61f4d5704cda$var$ModalEdit;

const $885da5432a01880a$var$ModalsCRUD = ({
  resource: resource,
  formInputs: formInputs,
}) => {
  return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
    children: [
      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
        (0, $1a0d490a6687c933$export$2e2bcd8739ae039),
        {
          resource: resource,
          formInputs: formInputs,
        }
      ),
      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
        (0, $3edc61f4d5704cda$export$2e2bcd8739ae039),
        {
          resource: resource,
          formInputs: formInputs,
        }
      ),
      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
        (0, $ca6474ef28c3aa2a$export$2e2bcd8739ae039),
        {
          resource: resource,
          formInputs: formInputs,
        }
      ),
      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
        (0, $830a7a2235425dde$export$2e2bcd8739ae039),
        {
          resource: resource,
        }
      ),
    ],
  });
};
var $885da5432a01880a$export$2e2bcd8739ae039 = $885da5432a01880a$var$ModalsCRUD;

const $840df7a24aa920e9$var$useTourStore = (0, $8zHUo$zustand.create)(
  (0, $8zHUo$zustandmiddleware.combine)(
    {
      tours: [],
    },
    set => ({
      createTour: id =>
        set(s => ({
          tours: [
            ...s.tours,
            {
              id: id,
              isRun: false,
            },
          ],
        })),
      runTour: id =>
        set(s => ({
          tours: s.tours.map(t => {
            if (t.id === id)
              return {
                id: id,
                isRun: true,
              };
            return t;
          }),
        })),
      stopTour: id =>
        set(s => ({
          tours: s.tours.map(t => {
            if (t.id === id)
              return {
                id: id,
                isRun: false,
              };
            return t;
          }),
        })),
      stopAll: () =>
        set(s => ({
          tours: s.tours.map(t => ({
            id: t.id,
            isRun: false,
          })),
        })),
    })
  )
);
var $840df7a24aa920e9$export$2e2bcd8739ae039 =
  $840df7a24aa920e9$var$useTourStore;

const $8d24efcb0a756ce5$var$TourDashboard = ({
  tourId: tourId,
  steps: steps,
}) => {
  const {
    tours: tours,
    runTour: runTour,
    stopTour: stopTour,
  } = (0, $840df7a24aa920e9$export$2e2bcd8739ae039)();
  const tour = tours.find(t => t.id == tourId);
  return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
    (0, $8zHUo$phpcreationfrontendcomponentsreact.Tour),
    {
      continuous: true,
      run: tour?.isRun,
      showSkipButton: true,
      steps: (0, $14899fc8b120af69$export$5ef1c346a2bc96ea)(steps, 'target'),
      callback: data => {
        const {
          action: action,
          type: type,
          index: index,
          status: status,
        } = data;
        if (
          // If close button clicked then close the tour
          action === (0, $8zHUo$reactjoyride.ACTIONS).CLOSE || // If skipped or end tour, then close the tour
          (status === (0, $8zHUo$reactjoyride.STATUS).SKIPPED && tour?.isRun) ||
          status === (0, $8zHUo$reactjoyride.STATUS).FINISHED
        )
          stopTour(tourId.toLocaleString());
      },
      showProgress: true,
    }
  );
};
var $8d24efcb0a756ce5$export$2e2bcd8739ae039 =
  $8d24efcb0a756ce5$var$TourDashboard;

const $77652c2fdc3f796a$var$SectionHeaderActions = ({
  tourId: tourId,
  resource: resource,
  fqcn_bui: fqcn_bui,
}) => {
  const { t: t } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
  const { runTour: runTour } = (0, $840df7a24aa920e9$export$2e2bcd8739ae039)();
  const { setModalAdd: setModalAdd } = (0,
  $05f0bdbc2fb3ad37$export$2e2bcd8739ae039)();
  return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
    id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, 'header'),
    className: 'ActionsMain absolute top-2 right-0 print:hidden',
    children: [
      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
        className: '',
      }),
      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
        className: 'flex md:space-x-20 pl-10 mr-3 px-2 pt-1',
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
          (0, $8zHUo$phpcreationfrontendcomponentsreact.Dropdown),
          {
            // style={{marginLeft:"500px"}}
            position: 'right',
            useChevron: true,
            icon: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
              (0, $8zHUo$phpcreationfrontendcomponentsreact.IconGlyphPlus),
              {
                fill: 'white',
                className: 'w-4 h-4 text-gray-100',
              }
            ),
            title: 'Add',
            id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
              fqcn_bui,
              'header',
              'add'
            ),
            size: 'small',
            bgcolor: 'blue-phpr',
            textcolor: 'gray-50',
            children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
              className: 'flex flex-col space-y-2 p-3',
              children: [
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                  (0, $8zHUo$phpcreationfrontendcomponentsreact.Button),
                  {
                    id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                      fqcn_bui,
                      'header',
                      'add-button'
                    ),
                    title: t('Quick'),
                    onClick: () => {
                      setModalAdd(true);
                    },
                    icon: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                      (0,
                      $8zHUo$phpcreationfrontendcomponentsreact.IconLightning),
                      {
                        className: 'w-4 h-4 text-white',
                      }
                    ),
                    size: 'xsmall',
                    className: 'rounded-md',
                  }
                ),
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                  (0, $parcel$interopDefault($8zHUo$nextlink)),
                  {
                    href: '/' + resource + '/new',
                    children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                      (0, $8zHUo$phpcreationfrontendcomponentsreact.Button),
                      {
                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                          fqcn_bui,
                          'header',
                          'add-link'
                        ),
                        title: t(`Detailed`),
                        variant: 'secondary',
                        icon: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                          (0,
                          $8zHUo$phpcreationfrontendcomponentsreact.IconTenant),
                          {
                            className: 'w-4 h-4 ',
                          }
                        ),
                        size: 'xsmall',
                        className: 'rounded-md',
                        onClick: () => {},
                      }
                    ),
                  }
                ),
              ],
            }),
          }
        ),
      }),
    ],
  });
};
var $77652c2fdc3f796a$export$2e2bcd8739ae039 =
  $77652c2fdc3f796a$var$SectionHeaderActions;

function $bd52373b999d1388$var$useDebounce(rawValue, timer) {
  const [debouncedValue, setDebouncedValue] = (0, $8zHUo$react.useState)(
    rawValue
  );
  (0, $8zHUo$react.useEffect)(() => {
    const timeout = setTimeout(() => {
      setDebouncedValue(rawValue);
    }, timer || 300);
    // component unmounting
    return () => {
      clearTimeout(timeout);
    };
  }, [rawValue]);
  return debouncedValue;
}
var $bd52373b999d1388$export$2e2bcd8739ae039 =
  $bd52373b999d1388$var$useDebounce;

const $92094302a1671a2b$var$ListingSearch = ({ id: id, qField: qField }) => {
  const {
    setQ: setQ,
    filters: filters,
    setQField: setQField,
  } = (0, $be91cef85354cc3d$export$2e2bcd8739ae039)();
  const [searchKeyword, setSearchKeyword] = (0, $8zHUo$react.useState)(
    filters.q ?? ''
  );
  const _debouncedSearchKeyword = (0, $bd52373b999d1388$export$2e2bcd8739ae039)(
    searchKeyword
  );
  // debounced search effect
  (0, $8zHUo$react.useEffect)(() => {
    setQField(qField);
    setQ(_debouncedSearchKeyword.trim());
  }, [_debouncedSearchKeyword]);
  //translate
  const { t: t } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
  return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
    className: 'w-full sm:max-w-sm',
    id: 'search_bar',
    children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
      (0, $8zHUo$phpcreationfrontendcomponentsreact.Input),
      {
        id: id,
        placeholder: t('search'),
        value: searchKeyword,
        onChange: e => {
          setSearchKeyword(e.target.value);
        },
        onKeyDownCapture: e => {
          if (e.key == 'Escape') setSearchKeyword('');
        },
        icon: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
          (0, $8zHUo$phpcreationfrontendcomponentsreact.IconSearch),
          {
            className: 'w-3 h-3 text-gray-400',
          }
        ),
        isClearable: searchKeyword.length != 0,
        handleClearField: () => setSearchKeyword(''),
      }
    ),
  });
};
var $92094302a1671a2b$export$2e2bcd8739ae039 =
  $92094302a1671a2b$var$ListingSearch;

const $d543f8c8b855d7a3$var$useInitializer = () => {
  const {
    filters: filters,
    setOrder: setOrder,
    setSort: setSort,
    setPageSize: setPageSize,
    setQ: setQ,
    setSpecific: setSpecific,
    clearAll: clearAll,
  } = (0, $be91cef85354cc3d$export$2e2bcd8739ae039)();
  const router = (0, $8zHUo$nextrouter.useRouter)();
  const [isInitialized, setInitialized] = (0, $8zHUo$react.useState)(false);
  // check if there is query params
  (0, $8zHUo$react.useEffect)(() => {
    if (router.isReady) {
      setSort(router.query?.sort?.toString());
      //@ts-ignore
      setOrder(router.query?.order?.toString());
      setPageSize(Number(router.query?.perPage ? router.query?.perPage : 25));
      setQ(router.query.q ? router.query.q.toString() : '');
      // we will set 'specific' object from the specific.items
      Object.keys(router.query ?? {})
        .filter(i => i.includes('specific.'))
        .forEach(item => {
          //@ts-ignore
          setSpecific(
            item.split('.')[1],
            (0, $parcel$interopDefault($8zHUo$lodash)).get(router.query, item)
          );
        });
      setInitialized(true);
      return () => {
        clearAll();
      };
    }
  }, [router.query]);
  return {
    isInitialized: isInitialized,
  };
};
var $d543f8c8b855d7a3$export$2e2bcd8739ae039 =
  $d543f8c8b855d7a3$var$useInitializer;

const $663f980a34b55794$export$4c10d3903c2b1d21 = filters => {
  let path = window.location.host + window.location.pathname;
  let queryparams = '';
  Object.keys(filters)
    .filter(k => k != 'specific')
    .forEach(key => {
      // if (key == 'list_id_tenant') return;
      //@ts-ignore
      queryparams = queryparams + `${key}=${filters[key] ?? ''}&`;
    });
  //@ts-ignore
  Object.keys(filters.specific).forEach(key => {
    //@ts-ignore
    queryparams = //@ts-ignore
      queryparams + `specific.${key}=${filters.specific[key] ?? ''}&`;
  });
  let final_url = path + '?' + queryparams;
  navigator.clipboard.writeText(final_url.substring(0, final_url.length - 1));
  console.table({
    final_url: final_url,
  });
  (0, $parcel$interopDefault($8zHUo$reacthottoast)).success('Url Copied!');
};
const $663f980a34b55794$export$5214cad95991575 = (key, array) => {
  let str = '';
  array.forEach(e => (str = str + '&' + key + '[]=' + e.toString()));
  return str;
};
const $663f980a34b55794$export$d822b0d3f034f5b9 = (item, selection) => {
  if (item.isMulti)
    return selection[item.key]
      ? selection[item.key].split(',').map(i => ({
          label: i,
          value: i,
        }))
      : [];
  return selection[item.key]
    ? {
        label: selection[item.key],
        value: selection[item.key],
      }
    : [];
};
const $663f980a34b55794$export$861e353297c6047e = () => {};

const $0703df66cf6d7c5d$var$MainFilters = ({
  isVisible: isVisible,
  resource: resource,
  filterFields: filterFields,
}) => {
  const queryClient = (0, $8zHUo$tanstackreactquery.useQueryClient)();
  const {
    filters: filters,
    setLimit: setLimit,
    setPage: setPage,
    setOffset: setOffset,
    clearFilters: clearFilters,
    setSpecific: setSpecific,
  } = (0, $be91cef85354cc3d$export$2e2bcd8739ae039)();
  const [selection, setSelection] = (0, $8zHUo$react.useState)({});
  const [show, setShow] = (0, $8zHUo$react.useState)(false);
  const router = (0, $8zHUo$nextrouter.useRouter)();
  const fetchItems = async (_filterFieldItem, qs) => {
    const re = await (0, $686ab0e2fb05f109$export$6079a388768cd3b7)(
      _filterFieldItem.targetResourceAsync ?? _filterFieldItem.key + 's',
      {
        id: '',
      },
      false
    );
    const r = re?.filter(i =>
      router.query['specific.' + qs]
        ?.toString()
        .split(',')
        ?.includes(i.id?.toString())
    );
    if (r?.length > 0) {
      let items = [];
      r.forEach(i => {
        items.push({
          value: i?.id,
          label: i?.toString,
        });
      });
      setSelection({
        ...selection,
        [_filterFieldItem.key]: items,
      });
    }
  };
  // // populate choices
  (0, $8zHUo$react.useEffect)(() => {
    if (router.isReady) {
      const { query: query } = router;
      let temp_selection = {};
      // show the filter card in case there is a 'specific ' item
      setShow(Object.keys(query).some(i => i.includes('specific')));
      // only get ['id','filter_name'...] from {'specifi.id':'value','specific.fi2':value}
      const QS_for_filters = Object.keys(query)
        .filter(i => i.includes('specific.'))
        .map(s => s.split('.')[1]);
      // ['id','filtername2']
      QS_for_filters.forEach(qs => {
        let _filterFieldItem = filterFields.find(i => i.key == qs);
        if (_filterFieldItem?.type == 'search')
          temp_selection[_filterFieldItem.key] = query['specific.' + qs];
        if (_filterFieldItem?.type == 'select_async') {
          if (_filterFieldItem.isMulti) fetchItems(_filterFieldItem, qs);
          else
            temp_selection[_filterFieldItem.key] =
              _filterFieldItem.optionsArrayFinite?.find(i =>
                query['specific.' + qs]?.includes(i.value)
              );
        }
      });
      setSelection(temp_selection);
    }
  }, [router.isReady]);
  //translate
  const { t: t } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
  if (!isVisible && !show) return null;
  return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
    className:
      'relative z-10 w-full flex items-center justify-between flex-wrap p-2 m-1 mt-2 border rounded-lg border-gray-100 main-filters',
    children: [
      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
        className: 'Title',
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('span', {
          className: 'text-sm text-gray-500 font-medium',
          children: t('Filters'),
        }),
      }),
      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
        className:
          'flex items-center justify-between flex-wrap w-full max-w-3xl',
        children: [
          filterFields
            .filter(f => f.type == 'select')
            .map(
              (
                item,
                key // item.optionsArrayFinite == undefined ?
              ) =>
                // <div className="px-1" key={key}>
                //   <Select
                //     variant="async"
                //     placeholder={t(item.placeholder)}
                //     isMulti={item.isMulti}
                //     defaultOptions
                //     cacheOptions={true}
                //     loadOptions={(input, callback) => {
                //       get_all_resource(
                //         item.targetResourceAsync ?? item.key + 's',
                //         { id: input },
                //         false
                //       )
                //         .then(res =>
                //           res.map((i: any) => {
                //             if (i.toString != undefined || i.toString != "") {
                //               return {
                //                 label: i.toString,
                //                 value: i.id };
                //             }
                //             else{
                //               return {
                //                 label: i.id,
                //                 value: i.id };
                //             }
                //           })
                //         )
                //         .then(data => callback(data));
                //     }}
                //     onChange={(newIds: any) => {
                //       console.log({ newIds });
                //       const new_selections = { ...selection };
                //       new_selections[item.key] = newIds;
                //       console.log({ new_selections });
                //       setSelection(new_selections);
                //     }}
                //     value={selection[item.key] ?? ''}
                //   />
                //   </div>:
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                  'div',
                  {
                    className: 'px-1 w-full md:max-w-xs max-w-full',
                    children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                      (0, $8zHUo$phpcreationfrontendcomponentsreact.Select),
                      {
                        variant: 'normal',
                        placeholder: t(item.placeholder),
                        isMulti: item.isMulti,
                        options: item.optionsArrayFinite,
                        onChange: newIds => {
                          selection[item.key] = newIds;
                          setSelection({
                            ...selection,
                          });
                        },
                        value: selection[item.key] ?? '',
                      }
                    ),
                  },
                  key
                )
            ),
          filterFields
            .filter(f => f.type == 'select_async')
            .map((item, key) =>
              /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                'div',
                {
                  className: 'px-1 w-full md:max-w-xs max-w-full',
                  children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.Select),
                    {
                      variant: 'async',
                      placeholder: t(item.placeholder),
                      isMulti: item.isMulti,
                      defaultOptions: true,
                      cacheOptions: true,
                      loadOptions: (input, callback) => {
                        (0, $686ab0e2fb05f109$export$6079a388768cd3b7)(
                          item.targetResourceAsync ?? item.key + 's',
                          {
                            id: input,
                          },
                          false
                        )
                          .then(res =>
                            res.map(i => {
                              // label : Default id redefine to if exist toString or if exist self propriety AKA 'status.status'
                              // label : Could be parameter redefined
                              // value : Default id redefine could be parameter redefined
                              if (i.toString)
                                return {
                                  label: i.toString,
                                  value: i.id,
                                };
                              else
                                return {
                                  label: i.id,
                                  value: i.id,
                                };
                            })
                          )
                          .then(data => callback(data));
                      },
                      onChange: newIds => {
                        const new_selections = {
                          ...selection,
                        };
                        new_selections[item.key] = newIds;
                        setSelection(new_selections);
                      },
                      value: selection[item.key] ?? '',
                    }
                  ),
                },
                key
              )
            ),
          filterFields
            .filter(f => f.type == 'search')
            .map((item, key) =>
              /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                'div',
                {
                  className: 'px-1 w-full md:max-w-xs max-w-full',
                  children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.Input),
                    {
                      placeholder: t(item.placeholder),
                      onChange: event => {
                        const new_selections = {
                          ...selection,
                        };
                        new_selections[item.key] = event.target.value;
                        setSelection(new_selections);
                      },
                      value: selection[item.key] ?? '',
                    }
                  ),
                },
                key
              )
            ),
        ],
      }),
      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
        className:
          'flex items-center space-x-3 w-full justify-end max-w-full lg:max-w-xs',
        children: [
          /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
            (0, $8zHUo$phpcreationfrontendcomponentsreact.Button),
            {
              className:
                'text-gray-500 hover:text-red-500 text-xs font-medium ',
              variant: 'neutral',
              color: 'red-400',
              onClick: () => {
                clearFilters();
                setSelection({});
              },
              icon: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                (0, $8zHUo$phpcreationfrontendcomponentsreact.IconGlyphTimes),
                {
                  className: 'w-6 h-6',
                  fill: 'white',
                }
              ),
              size: 'xsmall',
              tooltipTitle: 'Remove filters',
            }
          ),
          /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
            (0, $8zHUo$phpcreationfrontendcomponentsreact.Button),
            {
              className:
                'text-gray-500 hover:text-red-500 text-xs font-medium ',
              variant: 'neutral',
              color: 'red-400',
              onClick: () => {
                (0, $663f980a34b55794$export$4c10d3903c2b1d21)(filters);
              },
              size: 'xsmall',
              icon: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                (0, $8zHUo$phpcreationfrontendcomponentsreact.IconGlyphCopy),
                {
                  className: 'w-6 h-6',
                  fill: 'white',
                }
              ),
              tooltipTitle: 'Copy filters',
            }
          ),
          /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
            (0, $8zHUo$phpcreationfrontendcomponentsreact.Button),
            {
              title: t('Apply'),
              variant: 'secondary',
              size: 'medium',
              onClick: () => {
                let arr_object_from_keys = Object.keys(selection);
                arr_object_from_keys.forEach(item => {
                  // in case the filter field is  select, so we can convert from key: {lable:,value:} to : key:value
                  if (
                    filterFields
                      .find(f => f.key == item)
                      ?.type.includes('select')
                  ) {
                    if (filterFields.find(f => f.key == item)?.isMulti == true)
                      setSpecific(
                        item,
                        selection[item].map(i => i.value).toString()
                      );
                    if (!filterFields.find(f => f.key == item)?.isMulti)
                      setSpecific(item, selection[item].value.toString());
                  } else setSpecific(item, selection[item]);
                  // setSpecific(item, selection[item]);
                });
              },
              tooltipTitle: 'Apply filters',
            }
          ),
        ],
      }),
    ],
  });
};
var $0703df66cf6d7c5d$export$2e2bcd8739ae039 =
  $0703df66cf6d7c5d$var$MainFilters;

const $d77c90b328b7f9e7$var$_RESOURCE = 'tenants';
const $d77c90b328b7f9e7$var$Listing = ({
  resource: resource,
  appNav: appNav,
  mainTourSteps: mainTourSteps,
  fieldsAll: fieldsAll,
  fieldsExport: fieldsExport,
  formModalInputs: formModalInputs,
  mainColumns: mainColumns,
  fqcn_bui: fqcn_bui,
  qField: qField,
  filterFields: filterFields,
  defaultActions: defaultActions,
  selectedList: selectedList,
  pageTitle: pageTitle,
}) => {
  const _RESOURCE = resource;
  const {
    tours: tours,
    createTour: createTour,
    runTour: runTour,
  } = (0, $840df7a24aa920e9$export$2e2bcd8739ae039)();
  const tourId = `${_RESOURCE}-main`;
  const {
    filters: filters,
    clearAll: clearAll,
    clearFilters: clearFilters,
  } = (0, $be91cef85354cc3d$export$2e2bcd8739ae039)();
  const [isFiltersVisible, setIsFiltersVisible] = (0, $8zHUo$react.useState)(
    false
  );
  const queryClient = (0, $8zHUo$tanstackreactquery.useQueryClient)();
  const { isLoading: isInitialLoading } = (0,
  $49eb772184ca2f2b$export$ad6724ecf32710ae)(_RESOURCE, {}, true);
  const { refetch: refetch } = (0, $49eb772184ca2f2b$export$ad6724ecf32710ae)(
    _RESOURCE,
    filters,
    false
  );
  // check if there is query params
  const { isInitialized: isInitialized } = (0,
  $d543f8c8b855d7a3$export$2e2bcd8739ae039)();
  // Always refetch on componenent mounting
  (0, $8zHUo$react.useEffect)(() => {
    refetch();
    createTour(tourId);
  }, []);
  const { t: t } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
  return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
    (0, $8zHUo$phpcreationfrontendcomponentsreact.PageLayout),
    {
      fqcn_bui: fqcn_bui,
      title: _RESOURCE,
      pageTitle: pageTitle || _RESOURCE,
      appNav: appNav,
      breadcrumbNav: [
        {
          label: 'Home',
          url: '/',
        },
        {
          label: _RESOURCE,
          url: `/${_RESOURCE}`,
        },
      ],
      children: [
        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
          (0, $77652c2fdc3f796a$export$2e2bcd8739ae039),
          {
            fqcn_bui: fqcn_bui,
            tourId: tourId,
            resource: _RESOURCE,
          }
        ),
        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('article', {
          className: 'print:hidden',
          children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
            (0, $8zHUo$phpcreationfrontendcomponentsreact.Card),
            {
              loading: isInitialLoading,
              rows: 1,
              cols: 4,
              id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                fqcn_bui,
                '_filters'
              ),
              children: [
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
                  className:
                    'flex justify-between flex-col listing-header gap-3',
                  children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                      (0, $92094302a1671a2b$export$2e2bcd8739ae039),
                      {
                        qField: qField ?? 'id',
                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                          fqcn_bui,
                          'search',
                          'input'
                        ),
                      }
                    ),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
                      className:
                        'flex justify-between items-center gap-2 w-full max-w-3xl flex-wrap',
                      children: [
                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                          (0, $7e22cf9a2c0887ea$export$2e2bcd8739ae039),
                          {
                            fqcn_bui: fqcn_bui,
                            resource: _RESOURCE,
                            defaultFields: [...fieldsAll],
                            selectedList: selectedList || [...fieldsAll],
                          }
                        ),
                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                          (0, $908dddbc956107bd$export$2e2bcd8739ae039),
                          {
                            fqcn_bui: fqcn_bui,
                            resource: _RESOURCE,
                            fields: fieldsExport,
                          }
                        ),
                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                          (0, $8zHUo$phpcreationfrontendcomponentsreact.Button),
                          {
                            title: t('Filters'),
                            id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                              fqcn_bui,
                              'filters',
                              'filters-button'
                            ),
                            icon: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                              (0,
                              $8zHUo$phpcreationfrontendcomponentsreact.IconFilter),
                              {
                                className: `w-4 h-4`,
                              }
                            ),
                            onClick: () => {
                              setIsFiltersVisible(!isFiltersVisible);
                            },
                            className: 'rounded-lg',
                          }
                        ),
                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                          (0, $d104ffa792c5b78f$export$2e2bcd8739ae039),
                          {
                            fqcn_bui: fqcn_bui,
                            resource: _RESOURCE,
                            defaultActions: defaultActions ?? [
                              t('edit'),
                              t('delete'),
                              t('show'),
                              t('duplicate'),
                            ],
                          }
                        ),
                      ],
                    }),
                  ],
                }),
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                  (0, $0703df66cf6d7c5d$export$2e2bcd8739ae039),
                  {
                    isVisible: isFiltersVisible,
                    filterFields: filterFields,
                    resource: resource,
                  }
                ),
              ],
            }
          ),
        }),
        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('br', {}),
        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
          (0, $8zHUo$phpcreationfrontendcomponentsreact.Card),
          {
            loading: isInitialLoading,
            rows: 4,
            title: t(`${_RESOURCE} Listing`),
            children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
              className: 'w-full md:w-auto', // overflow-x-scroll
              style: {
                overflowX: mainColumns.length > 10 ? 'scroll' : 'clip',
              },
              children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                (0, $c092319464fa2356$export$2e2bcd8739ae039),
                {
                  fqcn_bui: fqcn_bui,
                  resource: _RESOURCE,
                  defaultColumns: mainColumns,
                }
              ),
            }),
          }
        ),
        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
          (0, $885da5432a01880a$export$2e2bcd8739ae039),
          {
            resource: _RESOURCE,
            formInputs: formModalInputs,
          }
        ),
        tours.find(t => t.id == tourId)?.isRun &&
          /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
            (0, $8d24efcb0a756ce5$export$2e2bcd8739ae039),
            {
              tourId: tourId,
              steps: mainTourSteps,
            }
          ),
      ],
    }
  );
};
var $d77c90b328b7f9e7$export$2e2bcd8739ae039 = $d77c90b328b7f9e7$var$Listing;

const $9a6c41ceee585a48$var$Create = ({
  resource: resource,
  appNav: appNav,
  formInputs: formInputs,
  fqcn_bui: fqcn_bui,
  pageTitle: pageTitle,
  selectedList: selectedList,
}) => {
  const router = (0, $8zHUo$nextrouter.useRouter)();
  const { id: id } = router.query;
  const { t: t } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
  const createMutation = (0, $49eb772184ca2f2b$export$5edc9d665968dd86)(
    resource
  );
  const [FormData, setFormData] = (0, $8zHUo$react.useState)({});
  const [check, setCheck] = (0, $8zHUo$react.useState)(false);
  const findRequiredField = (selectedList, label) => {
    for (let i = 0; i <= selectedList.length; i++) {
      if (selectedList[i] === label) return t(label) + ' *';
    }
    return t(label);
  };
  const handleCreateResource = async formData => {
    try {
      const res = await createMutation.mutateAsync(formData);
      router.push(`/${resource}/${res.id}`);
    } catch (error) {
      console.error('Failed to create resource', error);
    }
  };
  (0, $8zHUo$react.useEffect)(() => {
    let key_value_formData = {};
    formInputs.forEach(i => {
      //@ts-ignore
      key_value_formData[i.name] = router.query[i.name] ?? '';
    });
    setFormData(key_value_formData);
  }, [router.isReady]);
  // if (isError) return <p>eror</p>;
  return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
    (0, $8zHUo$phpcreationfrontendcomponentsreact.PageLayout),
    {
      fqcn_bui: fqcn_bui,
      title: t('Add ') + t(resource.toString().slice(0, resource.length - 1)),
      appNav: appNav,
      breadcrumbNav: [
        {
          label: 'Home',
          url: '/',
        },
        {
          label: resource,
          url: `/${resource}`,
        },
        {
          label: 'new',
          url: '#',
        },
      ],
      pageTitle: `${pageTitle} | Add`,
      children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
        className: 'py-4',
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('form', {
          id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, 'form'),
          className: 'flex flex-col items-start space-y-1',
          children: [
            //@ts-ignore
            formInputs.map((field, index) => {
              if (field.type == 'input')
                return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
                  'div',
                  {
                    id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                      fqcn_bui,
                      'form',
                      field.name
                    ),
                    className: 'flex flex-col items-start -space-y-2 text-sm',
                    children: [
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                          fqcn_bui,
                          'form',
                          field.name + '-label'
                        ),
                        children:
                          selectedList != undefined
                            ? findRequiredField(selectedList, field.name)
                            : t(field.label),
                      }),
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                        (0, $8zHUo$phpcreationfrontendcomponentsreact.Input),
                        {
                          id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                            fqcn_bui,
                            'form',
                            field.name + '-input'
                          ),
                          // size="large"
                          onChange: e =>
                            setFormData({
                              ...FormData,
                              [field.name]: e.target.value,
                            }),
                          value: FormData[field.name] ?? '',
                          placeholder: t(
                            field.placeholder ? field.placeholder : ''
                          ),
                        }
                      ),
                    ],
                  },
                  index
                );
              if (field.type == 'email')
                return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
                  'div',
                  {
                    id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                      fqcn_bui,
                      'form',
                      field.name
                    ),
                    className: 'flex flex-col items-start -space-y-2 text-sm',
                    children: [
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                          fqcn_bui,
                          'form',
                          field.name + '-label'
                        ),
                        children:
                          selectedList != undefined
                            ? findRequiredField(selectedList, field.name)
                            : t(field.label),
                      }),
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                        (0, $8zHUo$phpcreationfrontendcomponentsreact.Input),
                        {
                          type: 'email',
                          pattern: '[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$',
                          required: true,
                          id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                            fqcn_bui,
                            'form',
                            field.name + '-input'
                          ),
                          // size="large"
                          onChange: e =>
                            setFormData({
                              ...FormData,
                              [field.name]: e.target.value,
                            }),
                          value: FormData[field.name] ?? '',
                          placeholder: t(
                            field.placeholder ? field.placeholder : ''
                          ),
                        }
                      ),
                    ],
                  },
                  index
                );
              if (field.type == 'phone')
                return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
                  'div',
                  {
                    id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                      fqcn_bui,
                      'form',
                      field.name
                    ),
                    className: 'flex flex-col items-start -space-y-2 text-sm',
                    children: [
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                          fqcn_bui,
                          'form',
                          field.name + '-label'
                        ),
                        children:
                          selectedList != undefined
                            ? findRequiredField(selectedList, field.name)
                            : t(field.label),
                      }),
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                        (0, $8zHUo$phpcreationfrontendcomponentsreact.Input),
                        {
                          type: 'phone',
                          pattern: '[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$',
                          required: true,
                          id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                            fqcn_bui,
                            'form',
                            field.name + '-input'
                          ),
                          // size="large"
                          onChange: e =>
                            setFormData({
                              ...FormData,
                              [field.name]: e.target.value,
                            }),
                          value: FormData[field.name] ?? '',
                          placeholder: t(
                            field.placeholder ? field.placeholder : ''
                          ),
                        }
                      ),
                    ],
                  },
                  index
                );
              //CASE input
              if (field.type == 'text')
                return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
                  'div',
                  {
                    id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                      fqcn_bui,
                      'form',
                      field.name
                    ),
                    className: 'flex flex-col items-start -space-y-2 text-sm',
                    children: [
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                          fqcn_bui,
                          'form',
                          field.name + '-label'
                        ),
                        children:
                          selectedList != undefined
                            ? findRequiredField(selectedList, field.name)
                            : t(field.label),
                      }),
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('br', {}),
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                        (0, $8zHUo$phpcreationfrontendcomponentsreact.TextArea),
                        {
                          id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                            fqcn_bui,
                            'form',
                            field.name + '-input'
                          ),
                          onChange: e =>
                            setFormData({
                              ...FormData,
                              [field.name]: e.target.value,
                            }),
                          value: FormData[field.name] ?? '',
                          size: 'small',
                        }
                      ),
                    ],
                  },
                  index
                );
              // CASE Number
              if (field.type == 'number')
                return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
                  'div',
                  {
                    id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                      fqcn_bui,
                      'form',
                      field.name
                    ),
                    className: 'flex flex-col items-start -space-y-2 text-sm',
                    children: [
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                          fqcn_bui,
                          'form',
                          field.name + '-label'
                        ),
                        children:
                          selectedList != undefined
                            ? findRequiredField(selectedList, field.name)
                            : t(field.label),
                      }),
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('br', {}),
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                        (0, $8zHUo$phpcreationfrontendcomponentsreact.Input),
                        {
                          type: 'number',
                          id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                            fqcn_bui,
                            'form',
                            field.name + '-input'
                          ),
                          onChange: e =>
                            setFormData({
                              ...FormData,
                              [field.name]: parseInt(e.target.value),
                            }),
                          value: FormData[field.name] ?? '',
                          size: 'small',
                        }
                      ),
                    ],
                  },
                  index
                );
              // CASE Date
              if (field.type == 'date')
                return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
                  'div',
                  {
                    id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                      fqcn_bui,
                      'form',
                      field.name
                    ),
                    className: 'flex flex-col items-start -space-y-2 text-sm',
                    children: [
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                          fqcn_bui,
                          'form',
                          field.name + '-label'
                        ),
                        children:
                          selectedList != undefined
                            ? findRequiredField(selectedList, field.name)
                            : t(field.label),
                      }),
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                        (0, $8zHUo$phpcreationfrontendcomponentsreact.Input),
                        {
                          type: 'date',
                          id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                            fqcn_bui,
                            'form',
                            field.name + '-input'
                          ),
                          // size="large"
                          onChange: e =>
                            setFormData({
                              ...FormData,
                              [field.name]: e.target.value,
                            }),
                          value: FormData[field.name] ?? '',
                          placeholder: t(
                            field.placeholder ? field.placeholder : ''
                          ),
                        }
                      ),
                    ],
                  },
                  index
                );
              // CASE  Finite
              if (field.type == 'select')
                return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
                  id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                    fqcn_bui,
                    'form',
                    field.name
                  ),
                  className: 'flex flex-col items-start -space-y-0 text-sm',
                  children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                      id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                        fqcn_bui,
                        'form',
                        field.name + '-label'
                      ),
                      children:
                        selectedList != undefined
                          ? findRequiredField(selectedList, field.name)
                          : t(field.label),
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                      (0, $8zHUo$phpcreationfrontendcomponentsreact.Select),
                      {
                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                          fqcn_bui,
                          'form',
                          field.name + '-input'
                        ),
                        placeholder: t(
                          field.placeholder ? field.placeholder : ''
                        ),
                        options: field.optionsArrayFinite,
                        onChange: newIds => {
                          setFormData({
                            ...FormData,
                            [field.name]: newIds,
                          });
                        },
                        // label={ FormData[field.name]}
                        value: FormData[field.name],
                      }
                    ),
                  ],
                });
              // CASE Finite + Boolean
              if (field.type == 'checkbox')
                return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
                  id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                    fqcn_bui,
                    'form',
                    field.name
                  ),
                  className: 'flex flex-col items-start -space-y-0 text-sm',
                  children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                      id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                        fqcn_bui,
                        'form',
                        field.name + '-label'
                      ),
                      children:
                        selectedList != undefined
                          ? findRequiredField(selectedList, field.name)
                          : t(field.label),
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                      (0, $8zHUo$phpcreationfrontendcomponentsreact.Toggle),
                      {
                        style: {
                          backgroundColor:
                            FormData[field.name] && check ? 'blue' : 'red',
                        },
                        checkedChildren: 'True',
                        unCheckedChildren: 'False',
                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                          fqcn_bui,
                          'form',
                          field.name + '-input'
                        ),
                        onChange: newIds => {
                          setFormData({
                            ...FormData,
                            [field.name]: newIds,
                          });
                          setCheck(newIds);
                        },
                        defaultChecked: FormData[field.name],
                      },
                      FormData[field.name]
                    ),
                  ],
                });
              // CASE Not Finite == Load from server
              if (
                field.type == 'select_async' &&
                field.targetResourceAsync?.length
              )
                return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
                  id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                    fqcn_bui,
                    'form',
                    field.name
                  ),
                  className: 'flex flex-col items-start -space-y-0 text-sm',
                  children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                      id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                        fqcn_bui,
                        'form',
                        field.name + '-label'
                      ),
                      children:
                        selectedList != undefined
                          ? findRequiredField(selectedList, field.name)
                          : t(field.label),
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                      (0, $8zHUo$phpcreationfrontendcomponentsreact.Select),
                      {
                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                          fqcn_bui,
                          'form',
                          field.name + '-input'
                        ),
                        variant: 'async',
                        placeholder: t(
                          field.placeholder ? field.placeholder : ''
                        ),
                        defaultOptions: true,
                        cacheOptions: true,
                        loadOptions: (input, callback) => {
                          (0, $686ab0e2fb05f109$export$6079a388768cd3b7)(
                            `${field.targetResourceAsync}`,
                            {
                              id: input,
                            },
                            false
                          )
                            .then(res =>
                              res.map(i => {
                                return {
                                  label: field.resourceAsyncLabelParam
                                    ? (0,
                                      $parcel$interopDefault(
                                        $8zHUo$htmlreactparser
                                      ))(i[field.resourceAsyncLabelParam])
                                    : i.id,
                                  value: i.id,
                                };
                              })
                            )
                            .then(data => callback(data));
                        },
                        onChange: newIds => {
                          setFormData({
                            ...FormData,
                            [field.name]: newIds,
                          });
                        },
                        value: FormData[field.name],
                      }
                    ),
                  ],
                });
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
              className: 'flex w-full space-x-2 py-3 print:hidden',
              children: [
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                  (0, $parcel$interopDefault($8zHUo$nextlink)),
                  {
                    href: `/${resource}/${id}`,
                    passHref: true,
                    legacyBehavior: true,
                    children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                      (0, $8zHUo$phpcreationfrontendcomponentsreact.Button),
                      {
                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                          fqcn_bui,
                          'form',
                          'button-cancel'
                        ),
                        onClick: () => {},
                        variant: 'secondary',
                        title: t('Cancel'),
                        className: 'w-24 rounded-lg',
                      }
                    ),
                  }
                ),
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                  (0, $8zHUo$phpcreationfrontendcomponentsreact.Button),
                  {
                    id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                      fqcn_bui,
                      'form',
                      'button-submit'
                    ),
                    className: 'w-24 rounded-lg',
                    title: t('Create'),
                    isLoading: createMutation.isLoading,
                    onClick: async event => {
                      event.preventDefault();
                      let adjusted_formData = (0,
                      $64fb6a6b423817c8$export$5ea1bdf6a9d3779f)(
                        FormData,
                        formInputs
                      );
                      await handleCreateResource(adjusted_formData);
                    },
                  }
                ),
              ],
            }),
          ],
        }),
      }),
    }
  );
};
var $9a6c41ceee585a48$export$2e2bcd8739ae039 = $9a6c41ceee585a48$var$Create;

const $058824ee56add146$var$Edit = ({
  resource: resource,
  appNav: appNav,
  formInputs: formInputs,
  fqcn_bui: fqcn_bui,
  pageTitle: pageTitle,
}) => {
  const router = (0, $8zHUo$nextrouter.useRouter)();
  const { t: t } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
  const { id: id } = router.query;
  //@ts-ignore
  const {
    data: data,
    isLoading: isLoading,
    isSuccess: isSuccess,
    isError: isError,
  } = (0, $49eb772184ca2f2b$export$35d0477f0729096c)(resource, id);
  const {
    data: dataUpdate,
    isLoading: isLoadingUpdate,
    isSuccess: isSuccessUpdate,
    mutate: update_resource,
  } = (0, $49eb772184ca2f2b$export$74524c73191a667c)(resource);
  const [FormData, setFormData] = (0, $8zHUo$react.useState)({});
  (0, $8zHUo$react.useEffect)(() => {
    let key_value_formData = {};
    if (isSuccess) {
      formInputs.forEach(async i => {
        if (i.type == 'text')
          //@ts-ignore
          key_value_formData[i.name] = //@ts-ignore
            router.query[i.name] ??
            (0, $parcel$interopDefault($8zHUo$lodash)).get(
              data,
              i.itemSpecificPath ?? i.name
            );
        if (i.type == 'input')
          //@ts-ignore
          key_value_formData[i.name] = //@ts-ignore
            router.query[i.name] ??
            (0, $parcel$interopDefault($8zHUo$lodash)).get(
              data,
              i.itemSpecificPath ?? i.name
            );
        if (i.type == 'email')
          //@ts-ignore
          key_value_formData[i.name] = //@ts-ignore
            router.query[i.name] ??
            (0, $parcel$interopDefault($8zHUo$lodash)).get(
              data,
              i.itemSpecificPath ?? i.name
            );
        if (i.type == 'phone')
          //@ts-ignore
          key_value_formData[i.name] = //@ts-ignore
            router.query[i.name] ??
            (0, $parcel$interopDefault($8zHUo$lodash)).get(
              data,
              i.itemSpecificPath ?? i.name
            );
        if (i.type == 'checkbox')
          //@ts-ignore
          key_value_formData[i.name] = //@ts-ignore
            router.query[i.name] ??
            (0, $parcel$interopDefault($8zHUo$lodash)).get(
              data,
              i.itemSpecificPath ?? i.name
            );
        if (i.type == 'number')
          //@ts-ignore
          key_value_formData[i.name] = //@ts-ignore
            router.query[i.name] ??
            (0, $parcel$interopDefault($8zHUo$lodash)).get(
              data,
              i.itemSpecificPath ?? i.name
            );
        if (i.type == 'date')
          //@ts-ignore
          key_value_formData[i.name] = //@ts-ignore
            router.query[i.name] ??
            (0, $parcel$interopDefault($8zHUo$lodash)).get(
              data,
              i.itemSpecificPath ?? i.name
            );
        if (i.type == 'select')
          //@ts-ignore
          key_value_formData[i.name] = //@ts-ignore
            router.query[i.name] ??
            (0, $parcel$interopDefault($8zHUo$lodash)).get(
              data,
              i.itemSpecificPath ?? i.name
            );
        if (i.type == 'checkbox')
          //@ts-ignore
          key_value_formData[i.name] = //@ts-ignore
            router.query[i.name] ??
            (0, $parcel$interopDefault($8zHUo$lodash)).get(
              data,
              i.itemSpecificPath ?? i.name
            );
        if (i.type == 'select_async') {
          const id = Number(data[i.name]?.id); //data[i.name].replace(i.prefixOnSubmit, '')
          //@ts-ignore
          key_value_formData[i.name] = {
            label: '',
            value: id,
          };
          const resource = await (0, $686ab0e2fb05f109$export$7d1eefcddaeba55b)(
            `${i.targetResourceAsync}`,
            data[i.name]?.id
          ); //data[i.name].replace(i.prefixOnSubmit, '')
          //@ts-ignore
          key_value_formData[i.name].label = i.resourceAsyncLabelParam
            ? (0, $parcel$interopDefault($8zHUo$htmlreactparser))(
                resource[i.resourceAsyncLabelParam]
              )
            : id;
        }
      });
      setFormData(key_value_formData);
    }
  }, [isSuccess]);
  if (isError)
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('p', {
      children: 'eror',
    });
  return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
    (0, $8zHUo$phpcreationfrontendcomponentsreact.PageLayout),
    {
      fqcn_bui: fqcn_bui,
      title: t('Edit ') + t(resource.toString().slice(0, resource.length - 1)),
      pageTitle: `${pageTitle} #${id} | Edit`,
      breadcrumbNav: [
        {
          label: 'Home',
          url: '/',
        },
        {
          label: resource,
          url: `/${resource}`,
        },
        {
          label: id ? id.toString() : 'd',
          url: `/${resource}/${id?.toString()}`,
        },
        {
          label: 'edit',
          url: `/${resource}/${id?.toString()}/edit`,
        },
      ],
      appNav: appNav,
      children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('form', {
        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, 'form'),
        className: 'flex flex-col items-start space-y-1 py-4',
        children: [
          /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
            id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
              fqcn_bui,
              'form',
              'id'
            ),
            className: 'flex flex-col items-start -space-y-2 text-sm',
            children: [
              /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                  fqcn_bui,
                  'form',
                  'id-label'
                ),
                children: t(resource + ' ID'),
              }),
              /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                (0, $8zHUo$phpcreationfrontendcomponentsreact.Input),
                {
                  id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                    fqcn_bui,
                    'form',
                    'id-input'
                  ),
                  // size="large"
                  disabled: true,
                  placeholder: id?.toLocaleString(),
                }
              ),
            ],
          }),
          //@ts-ignore
          formInputs?.map((field, index) => {
            if (field.type == 'input')
              return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
                'div',
                {
                  id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                    fqcn_bui,
                    'form',
                    field.name
                  ),
                  className: 'flex flex-col items-start -space-y-2 text-sm',
                  children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                      id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                        fqcn_bui,
                        'form',
                        field.name + '-label'
                      ),
                      children: t(field.label),
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                      (0, $8zHUo$phpcreationfrontendcomponentsreact.Input),
                      {
                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                          fqcn_bui,
                          'form',
                          field.name + '-input'
                        ),
                        // size="large"
                        onChange: e =>
                          setFormData({
                            ...FormData,
                            [field.name]: e.target.value,
                          }),
                        value: FormData[field.name] ?? '',
                        placeholder: t(
                          field.placeholder ? field.placeholder : ''
                        ),
                      }
                    ),
                  ],
                },
                index
              );
            if (field.type == 'email')
              return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
                'div',
                {
                  className: 'flex flex-col items-start -space-y-2 text-sm',
                  children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                      children: t(field.label),
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                      (0, $8zHUo$phpcreationfrontendcomponentsreact.Input),
                      {
                        type: 'email',
                        pattern: '[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$',
                        required: true,
                        // size="large"
                        onChange: e =>
                          setFormData({
                            ...FormData,
                            [field.name]: e.target.value,
                          }),
                        value: FormData[field.name] ?? '',
                        placeholder: `${t(field.placeholder ?? '')}`,
                      }
                    ),
                  ],
                },
                index
              );
            if (field.type == 'phone')
              return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
                'div',
                {
                  className: 'flex flex-col items-start -space-y-2 text-sm',
                  children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                      children: t(field.label),
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                      (0, $8zHUo$phpcreationfrontendcomponentsreact.Input),
                      {
                        type: 'phone',
                        pattern: '[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$',
                        required: true,
                        // size="large"
                        onChange: e =>
                          setFormData({
                            ...FormData,
                            [field.name]: e.target.value,
                          }),
                        value: FormData[field.name] ?? '',
                        placeholder: `${t(field.placeholder ?? '')}`,
                      }
                    ),
                  ],
                },
                index
              );
            if (field.type == 'number')
              return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
                'div',
                {
                  className: 'flex flex-col items-start -space-y-2 text-sm',
                  children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                      children: t(field.label),
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                      (0, $8zHUo$phpcreationfrontendcomponentsreact.Input),
                      {
                        type: 'number',
                        // size="large"
                        onChange: e =>
                          setFormData({
                            ...FormData,
                            [field.name]: parseInt(e.target.value),
                          }),
                        value: FormData[field.name] ?? '',
                        placeholder: `${t(field.placeholder ?? '')}`,
                      }
                    ),
                  ],
                },
                index
              );
            // CASE Date
            if (field.type == 'date')
              return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
                'div',
                {
                  id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                    fqcn_bui,
                    'form',
                    field.name
                  ),
                  className: 'flex flex-col items-start -space-y-2 text-sm',
                  children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                      id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                        fqcn_bui,
                        'form',
                        field.name + '-label'
                      ),
                      children: t(field.name),
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                      (0, $8zHUo$phpcreationfrontendcomponentsreact.Input),
                      {
                        type: 'date',
                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                          fqcn_bui,
                          'form',
                          field.name + '-input'
                        ),
                        // size="large"
                        onChange: e =>
                          setFormData({
                            ...FormData,
                            [field.name]: e.target.value,
                          }),
                        value: FormData[field.name] ?? '',
                        placeholder: t(
                          field.placeholder ? field.placeholder : ''
                        ),
                      }
                    ),
                  ],
                },
                index
              );
            // CASE  Finite
            if (field.type == 'select')
              return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
                id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                  fqcn_bui,
                  'form',
                  field.name
                ),
                className: 'flex flex-col items-start -space-y-0 text-sm',
                children: [
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                    id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                      fqcn_bui,
                      'form',
                      field.name + '-label'
                    ),
                    children: t(field.label),
                  }),
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.Select),
                    {
                      id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                        fqcn_bui,
                        'form',
                        field.name + '-input'
                      ),
                      placeholder: t(
                        field.placeholder ? field.placeholder : ''
                      ),
                      options: field.optionsArrayFinite,
                      onChange: newIds => {
                        setFormData({
                          ...FormData,
                          [field.name]: newIds,
                        });
                      },
                      value: FormData[field.name],
                    }
                  ),
                ],
              });
            // CASE Not Finite== Load from server
            if (
              field.type == 'select_async' &&
              field.targetResourceAsync?.length
            )
              console.log('FormData[field.name]', FormData[field.name]);
            return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
              id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                fqcn_bui,
                'form',
                field.name
              ),
              className: 'flex flex-col items-start -space-y-0 text-sm',
              children: [
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                  id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                    fqcn_bui,
                    'form',
                    field.name + '-label'
                  ),
                  children: t(field.label),
                }),
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                  (0, $8zHUo$phpcreationfrontendcomponentsreact.Select),
                  {
                    id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                      fqcn_bui,
                      'form',
                      field.name + '-input'
                    ),
                    variant: 'async',
                    placeholder: t(field.placeholder ? field.placeholder : ''),
                    defaultOptions: true,
                    cacheOptions: true,
                    loadOptions: (input, callback) => {
                      (0, $686ab0e2fb05f109$export$6079a388768cd3b7)(
                        `${field.targetResourceAsync}`,
                        {
                          id: input,
                        },
                        false
                      )
                        .then(res =>
                          res?.map(i => {
                            return {
                              label: field.resourceAsyncLabelParam
                                ? (0,
                                  $parcel$interopDefault(
                                    $8zHUo$htmlreactparser
                                  ))(i[field.resourceAsyncLabelParam])
                                : i.id,
                              value: i.id,
                            };
                          })
                        )
                        .then(data => callback(data));
                    },
                    onChange: newIds => {
                      setFormData({
                        ...FormData,
                        [field.name]: newIds,
                      });
                    },
                    value: FormData[field.name],
                  }
                ),
              ],
            });
          }),
          /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
            className: 'flex w-full space-x-2 py-3 print:hidden',
            children: [
              /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                (0, $parcel$interopDefault($8zHUo$nextlink)),
                {
                  href: `/${resource}/${id}`,
                  passHref: true,
                  legacyBehavior: true,
                  children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.Button),
                    {
                      id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                        fqcn_bui,
                        'form',
                        'button-cancel'
                      ),
                      onClick: () => {},
                      variant: 'secondary',
                      title: t('Cancel'),
                      className: 'w-24 rounded-lg',
                    }
                  ),
                }
              ),
              /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                (0, $8zHUo$phpcreationfrontendcomponentsreact.Button),
                {
                  id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                    fqcn_bui,
                    'form',
                    'button-submit'
                  ),
                  className: 'w-24 rounded-lg',
                  title: t('Edit'),
                  isLoading: isLoadingUpdate,
                  onClick: event => {
                    event.preventDefault();
                    // adding this in case of relationtional entities
                    let adjusted_formData = (0,
                    $64fb6a6b423817c8$export$5ea1bdf6a9d3779f)(
                      FormData,
                      formInputs
                    );
                    //@ts-ignore
                    update_resource({
                      id: Number(id),
                      ...adjusted_formData,
                    });
                    router.push(`/${resource}/${id}`);
                  },
                }
              ),
            ],
          }),
        ],
      }),
    }
  );
};
var $058824ee56add146$export$2e2bcd8739ae039 = $058824ee56add146$var$Edit;

const $2a23ce9281f716ef$var$General = ({
  resource: resource,
  displayedFields: displayedFields,
  data: data,
  loading: loading,
  fqcn_bui: fqcn_bui,
}) => {
  const { t: t } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
  return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
    (0, $8zHUo$phpcreationfrontendcomponentsreact.Card),
    {
      loading: loading,
      rows: 8,
      cols: 2,
      title: `${t(resource.toString().slice(0, resource.length - 1))} ${t(
        'information'
      )}`,
      children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, 'general'),
        className:
          '__Wrapper flex flex-col space-y-3 p-2 overflow-x-hidden text-ellipsis max-w-2xl',
        children: displayedFields.map(
          (item, key) =>
            (0, $parcel$interopDefault($8zHUo$lodash)).get(data, item.path) &&
            (item.type == 'iri'
              ? /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
                  'div',
                  {
                    id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                      fqcn_bui,
                      'general',
                      item.key
                    ),
                    className: 'flex flex-col ',
                    children: [
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('span', {
                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                          fqcn_bui,
                          'general',
                          item.key + '-title'
                        ),
                        className: '__label text-sm text-gray-500',
                        children: t(item.key.split('.')[0]),
                      }),
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('span', {
                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                          fqcn_bui,
                          'general',
                          item.key + '-value'
                        ),
                        className: '__value font-medium text-base ',
                        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                          (0, $parcel$interopDefault($8zHUo$nextlink)),
                          {
                            href: `/${item.entity}/${(0,
                            $parcel$interopDefault($8zHUo$lodash)).get(
                              data,
                              item.key
                            )}`,
                            children: /*#__PURE__*/ (0,
                            $8zHUo$reactjsxruntime.jsx)('a', {
                              id: (0,
                              $14899fc8b120af69$export$c11f7f0cac96af2a)(
                                fqcn_bui,
                                'list',
                                item.key + '-link'
                              ),
                              children: (0,
                              $parcel$interopDefault($8zHUo$lodash)).get(
                                data,
                                item.path
                              ),
                            }),
                          }
                        ),
                      }),
                    ],
                  },
                  key
                )
              : item.type == 'email'
              ? /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
                  'div',
                  {
                    id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                      fqcn_bui,
                      'general',
                      item.key
                    ),
                    className: 'flex flex-col ',
                    children: [
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('span', {
                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                          fqcn_bui,
                          'general',
                          item.key + '-title'
                        ),
                        className: '__label text-sm text-gray-500',
                        children: t(item.key),
                      }),
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('span', {
                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                          fqcn_bui,
                          'general',
                          item.key + '-value'
                        ),
                        className: '__value font-medium text-base ',
                        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                          'a',
                          {
                            href: `mailto:${(0,
                            $parcel$interopDefault($8zHUo$lodash)).get(
                              data,
                              item.path
                            )}`,
                            children: (0,
                            $parcel$interopDefault($8zHUo$lodash)).get(
                              data,
                              item.path
                            ),
                          }
                        ),
                      }),
                    ],
                  },
                  key
                )
              : item.type == 'phone'
              ? /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
                  'div',
                  {
                    id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                      fqcn_bui,
                      'general',
                      item.key
                    ),
                    className: 'flex flex-col ',
                    children: [
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('span', {
                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                          fqcn_bui,
                          'general',
                          item.key + '-title'
                        ),
                        className: '__label text-sm text-gray-500',
                        children: t(item.key),
                      }),
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('span', {
                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                          fqcn_bui,
                          'general',
                          item.key + '-value'
                        ),
                        className: '__value font-medium text-base ',
                        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                          'a',
                          {
                            href: `tel:${(0,
                            $parcel$interopDefault($8zHUo$lodash)).get(
                              data,
                              item.path
                            )}`,
                            children: (0,
                            $parcel$interopDefault($8zHUo$lodash)).get(
                              data,
                              item.path
                            ),
                          }
                        ),
                      }),
                    ],
                  },
                  key
                )
              : item.type == 'url'
              ? /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
                  'div',
                  {
                    id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                      fqcn_bui,
                      'general',
                      item.key
                    ),
                    className: 'flex flex-col ',
                    children: [
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('span', {
                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                          fqcn_bui,
                          'general',
                          item.key + '-title'
                        ),
                        className: '__label text-sm text-gray-500',
                        children: t(item.key),
                      }),
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('span', {
                        className: '__value font-medium text-base ',
                        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                          'a',
                          {
                            href: `${(0,
                            $parcel$interopDefault($8zHUo$lodash)).get(
                              data,
                              item.path
                            )}`,
                            target: '_blank',
                            rel: 'noopener noreferrer',
                            children: (0,
                            $parcel$interopDefault($8zHUo$lodash)).get(
                              data,
                              item.path
                            ),
                          }
                        ),
                      }),
                    ],
                  },
                  key
                )
              : item.type == 'ul'
              ? /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
                  'div',
                  {
                    id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                      fqcn_bui,
                      'general',
                      item.key
                    ),
                    className: 'flex flex-col ',
                    children: [
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('span', {
                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                          fqcn_bui,
                          'general',
                          item.key + '-title'
                        ),
                        className: '__label text-sm text-gray-500',
                        children: t(item.key),
                      }),
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('span', {
                        className: '__value font-medium text-base ',
                        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                          'ul',
                          {
                            children: (0, $parcel$interopDefault($8zHUo$lodash))
                              .get(data, item.path)
                              ?.map(item =>
                                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                                  'li',
                                  {
                                    children: item,
                                  },
                                  item
                                )
                              ),
                          }
                        ),
                      }),
                    ],
                  },
                  key
                )
              : item.type == 'date'
              ? /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
                  'div',
                  {
                    id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                      fqcn_bui,
                      'general',
                      item.key
                    ),
                    className: 'flex flex-col ',
                    children: [
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('span', {
                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                          fqcn_bui,
                          'general',
                          item.key + '-title'
                        ),
                        className: '__label text-sm text-gray-500',
                        children: t(item.key),
                      }),
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('span', {
                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                          fqcn_bui,
                          'general',
                          item.key + '-value'
                        ),
                        className: '__value font-medium text-base ',
                        children: (0, $parcel$interopDefault($8zHUo$moment))(
                          (0, $parcel$interopDefault($8zHUo$lodash)).get(
                            data,
                            item.path
                          )
                        ).format('YYYY-MM-DD HH:mm'),
                      }),
                    ],
                  },
                  key
                )
              : /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
                  'div',
                  {
                    id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                      fqcn_bui,
                      'general',
                      item.key
                    ),
                    className: 'flex flex-col ',
                    children: [
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('span', {
                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                          fqcn_bui,
                          'general',
                          item.key + '-title'
                        ),
                        className: '__label text-sm text-gray-500',
                        children: t(item.key),
                      }),
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('span', {
                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                          fqcn_bui,
                          'general',
                          item.key + '-value'
                        ),
                        className:
                          '__value font-medium text-base max-w-full text-ellipsis overflow-x-hidden',
                        children: (0,
                        $parcel$interopDefault($8zHUo$lodash)).get(
                          data,
                          item.path
                        ),
                      }),
                    ],
                  },
                  key
                ))
        ),
      }),
    }
  );
};
var $2a23ce9281f716ef$export$2e2bcd8739ae039 = $2a23ce9281f716ef$var$General;

const $2db5232dc991548d$var$TableListingSide = ({
  resource: resource,
  defaultColumns: defaultColumns,
  id: id,
  fqcn_bui: fqcn_bui,
}) => {
  const { closeAllModals: closeAllModals } = (0,
  $05f0bdbc2fb3ad37$export$2e2bcd8739ae039)();
  const {
    fields: fields,
    filters: filters,
    selectedActions: selectedActions,
    setPage: setPage,
    setPageSize: setPageSize,
  } = (0, $be91cef85354cc3d$export$2e2bcd8739ae039)();
  const router = (0, $8zHUo$nextrouter.useRouter)();
  const {
    isLoading: issLoading,
    isError: isError,
    isSuccess: isSuccess,
    data: data,
    refetch: refetch,
  } = (0, $49eb772184ca2f2b$export$ad6724ecf32710ae)(
    resource,
    {
      pageSize: 10,
      specific: {
        tenant: id?.toString(),
      },
    },
    true
  );
  const queryClient = (0, $8zHUo$tanstackreactquery.useQueryClient)();
  const ismutating = (0, $8zHUo$tanstackreactquery.useIsMutating)();
  (0, $8zHUo$react.useEffect)(() => {
    const TO = setTimeout(() => {
      closeAllModals();
    }, 600);
    return () => clearTimeout(TO);
  }, [ismutating]);
  // useEffect(() => {
  // console.log('hello', ismutating);
  // }, [ismutating]);
  return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
    className: 'border rounded-md border-gray-100 p-1',
    id: id,
    children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
      (0, $8zHUo$phpcreationfrontendcomponentsreact.Table),
      {
        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, 'list'),
        rowClassName: 'cursor-pointer',
        rowKey: 'id',
        onRow: (record, rowIndex) => {
          return {
            onClick: event => {
              const target = event.target;
              const isLink = target.tagName === 'A' || target.closest('a');
              // let route = router.asPath.split('/')[1];
              // if (route.endsWith('s')) {
              //   route = route.slice(0, -1);
              // }
              const newPath = `/${resource}/${record.id}`;
              if (!isLink) {
                if (event.ctrlKey) window.open(newPath, '_blank');
                else router.push(newPath);
              }
            },
          };
        },
        columns: (0, $bdbe64709c52488d$export$2e2bcd8739ae039)(
          resource,
          defaultColumns,
          fqcn_bui,
          true
        ),
        // columns={useListingColumns(resource).filter(col =>
        //   fields?.includes(col.key)
        // )}
        loading: ismutating == 1,
        dataSource: data
          ? [
              ...data['hydra:member'].map(e => ({
                ...e,
                selectedActions: selectedActions,
              })),
            ]
          : [],
        onChange: (pagination, filters, sorter) => {
          setPage(pagination.current);
          setPageSize(pagination.pageSize ? pagination.pageSize : 10);
        },
        pagination: false,
        // pagination={{
        //   pageSize: filters.pageSize ? filters.pageSize : 10,
        //   current: filters.page ? filters.page : 1,
        //   showSizeChanger: true,
        //   total: data && data['hydra:totalItems'],
        //   pageSizeOptions: [5, 25, 100, 500, 1000],
        //   position: ['bottomRight'],
        //   showTotal: (total, range) =>
        //     `${range[0]}-${range[1]} of ${total} items`,
        //   style: {
        //     marginBottom: '14px',
        //   },
        // }}
        scroll: {
          x: true,
        },
      }
    ),
  });
};
var $2db5232dc991548d$export$2e2bcd8739ae039 =
  $2db5232dc991548d$var$TableListingSide;

const $8a73ef8dafb8b269$var$Show = ({
  resource: resource,
  appNav: appNav,
  formInputs: formInputs,
  displayFields: displayFields,
  sideBoxs: sideBoxs,
  fqcn_bui: fqcn_bui,
  customActions: customActions,
  customShows: customShows,
  pageTitle: pageTitle,
  systemInfo: systemInfo,
}) => {
  const { t: t } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
  const { filters: filters, clearAll: clearAll } = (0,
  $be91cef85354cc3d$export$2e2bcd8739ae039)();
  const { modalDelete: modalDelete, setModalDelete: setModalDelete } = (0,
  $05f0bdbc2fb3ad37$export$2e2bcd8739ae039)();
  const [isExpanded, setIsExpanded] = (0, $8zHUo$react.useState)(false);
  const router = (0, $8zHUo$nextrouter.useRouter)();
  const { id: id } = router.query;
  //@ts-ignore
  const {
    isLoading: isInitialLoading,
    isError: isError,
    isSuccess: isSuccessInitial,
    data: data_show,
    refetch: refetch,
  } = (0, $49eb772184ca2f2b$export$35d0477f0729096c)(resource, Number(id));
  // Always refetch on componenent mounting
  (0, $8zHUo$react.useEffect)(() => {
    // in case of deletion close modal and change router
    if (id && isError) {
      setModalDelete(false);
      setTimeout(() => {
        (0, $parcel$interopDefault($8zHUo$reacthottoast)).success(
          'Redirecting...'
        );
      }, 400);
      setTimeout(() => router.push('/' + resource), 900);
    }
    // unmounting effect to remove all filters
    return () => {
      clearAll();
    };
  }, [isError]);
  // check if there is query params
  const { isInitialized: isInitialized } = (0,
  $d543f8c8b855d7a3$export$2e2bcd8739ae039)();
  if (!id) return null;
  return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
    (0, $8zHUo$phpcreationfrontendcomponentsreact.PageLayout),
    {
      fqcn_bui: fqcn_bui,
      title: resource,
      appNav: appNav,
      pageTitle: `${pageTitle} #${id}` || resource,
      breadcrumbNav: [
        {
          label: 'Home',
          url: '/',
        },
        {
          label: resource,
          url: `/${resource}`,
        },
        {
          label: id ? id.toString() : 'd',
          url: `/${resource}/${id?.toString()}`,
        },
      ],
      children: [
        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
          id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
            fqcn_bui,
            'actions'
          ),
          className: 'pb-4 print:hidden',
          children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
            className: 'flex w-1/5 gap-6',
            children: customActions?.map(elt =>
              /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                'div',
                {
                  children:
                    elt == 'edit'
                      ? /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                          (0, $8zHUo$phpcreationfrontendcomponentsreact.Button),
                          {
                            className: 'flex flex-1 justify-center',
                            title: t('Edit'),
                            variant: 'primary',
                            id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                              fqcn_bui,
                              'actions',
                              'edit-button'
                            ),
                            icon: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                              (0,
                              $8zHUo$phpcreationfrontendcomponentsreact.IconEdit),
                              {
                                className: 'w-4 h-4 text-blue-login',
                              }
                            ),
                            onClick: () =>
                              router.push('/' + resource + '/' + id + '/edit'),
                          }
                        )
                      : elt == 'delete'
                      ? /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                          (0, $8zHUo$phpcreationfrontendcomponentsreact.Button),
                          {
                            className: 'flex flex-1 justify-center',
                            id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                              fqcn_bui,
                              'actions',
                              'delete-button'
                            ),
                            title: t('Delete'),
                            variant: 'urgent',
                            icon: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                              (0,
                              $8zHUo$phpcreationfrontendcomponentsreact.IconTrash),
                              {
                                className: 'w-4 h-4',
                              }
                            ),
                            onClick: () => {
                              setModalDelete(true, {
                                id: id,
                              });
                            },
                          }
                        )
                      : elt == 'print'
                      ? /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                          (0, $8zHUo$phpcreationfrontendcomponentsreact.Button),
                          {
                            className:
                              'flex flex-1 justify-center border-[1px]',
                            id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                              fqcn_bui,
                              'actions',
                              'print-button'
                            ),
                            title: t('Print'),
                            icon: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                              (0,
                              $8zHUo$phpcreationfrontendcomponentsreact.IconPrint),
                              {
                                className: 'w-4 h-4',
                              }
                            ),
                            onClick: () => {
                              setIsExpanded(true);
                              setTimeout(() => window.print(), 1000);
                            },
                            bgcolor: 'transparent',
                            color: 'gray-500',
                            bordercolor: 'gray-400',
                          }
                        )
                      : null,
                },
                elt
              )
            ),
          }),
        }),
        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
          className: 'flex flex-wrap gap-5 overflow-x-hidden',
          children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
              className: 'flex-1 flex flex-col gap-5 w-full',
              children: [
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                  (0, $2a23ce9281f716ef$export$2e2bcd8739ae039),
                  {
                    fqcn_bui: fqcn_bui,
                    loading: isInitialLoading,
                    data: data_show,
                    resource: resource,
                    displayedFields: displayFields,
                  }
                ),
                systemInfo &&
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $2a23ce9281f716ef$export$2e2bcd8739ae039),
                    {
                      fqcn_bui: fqcn_bui,
                      loading: isInitialLoading,
                      data: data_show,
                      resource: 'Systems',
                      displayedFields: systemInfo,
                    }
                  ),
              ],
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
              className: 'flex-1 flex-col space-y-5 expander-sidebox w-full',
              children: [
                sideBoxs &&
                  sideBoxs.map((sidebox, index) => {
                    let route = router.asPath.split('/')[1];
                    if (route.endsWith('s')) route = route.slice(0, -1);
                    const newPath = `/${sidebox.subresource}?specific.${route}=${router.query.id}`;
                    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                      (0, $8zHUo$phpcreationfrontendcomponentsreact.Expander),
                      {
                        id: `${(0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                          fqcn_bui,
                          'general',
                          sidebox.subresource + '-expander'
                        )} `,
                        title: `${
                          t(sidebox.subresource).charAt(0).toUpperCase() +
                          t(sidebox.subresource).slice(1)
                        }`,
                        icon: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                          (0,
                          $8zHUo$phpcreationfrontendcomponentsreact.IconGlyphList),
                          {
                            className: 'w-4 mt-1 ml-1',
                          }
                        ),
                        maxHeight: 'screen',
                        isHeaderHighlighted: true,
                        isExpanded: isExpanded,
                        border: true,
                        iconLink: newPath,
                        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                          'div',
                          {
                            className: '',
                            id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                              fqcn_bui,
                              'general',
                              sidebox.subresource + '-table'
                            ),
                            children: /*#__PURE__*/ (0,
                            $8zHUo$reactjsxruntime.jsx)(
                              (0, $2db5232dc991548d$export$2e2bcd8739ae039),
                              {
                                fqcn_bui: fqcn_bui,
                                resource: sidebox.subresource,
                                id: id.toString(),
                                defaultColumns: sidebox.defaultColumns,
                              },
                              index
                            ),
                          }
                        ),
                      },
                      index
                    );
                  }),
                customShows,
              ],
            }),
          ],
        }),
        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
          (0, $885da5432a01880a$export$2e2bcd8739ae039),
          {
            resource: resource,
            formInputs: formInputs,
          }
        ),
      ],
    }
  );
};
var $8a73ef8dafb8b269$export$2e2bcd8739ae039 = $8a73ef8dafb8b269$var$Show;

const $86202e92a5a14a28$export$1450827b9d4328b4 = [
  {
    icon: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
      (0, $8zHUo$phpcreationfrontendcomponentsreact.IconDashboard),
      {
        className: 'text-inherit w-5 h-5 ',
      }
    ),
    label: 'Dashboard',
    url: '/dashboard',
  },
  {
    label: 'tenants',
    url: '/tenants',
    icon: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
      (0, $8zHUo$phpcreationfrontendcomponentsreact.IconTenant),
      {
        className: 'text-inherit w-4 h-4 ',
      }
    ),
  },
  {
    label: 'hostnames',
    url: '/hostnames',
    icon: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
      (0, $8zHUo$phpcreationfrontendcomponentsreact.IconHostname),
      {
        className: 'text-inherit w-4 h-4 ',
      }
    ),
  },
  {
    label: 'parameters',
    url: '/parameters',
    icon: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
      (0, $8zHUo$phpcreationfrontendcomponentsreact.IconParameter),
      {
        className: 'text-inherit w-4 h-4 ',
      }
    ),
  },
];

const $babf57e211862dcf$var$Homepage = ({
  appNav: appNav,
  heroTitle: heroTitle,
  heroDesc: heroDesc,
  fqcn_bui: fqcn_bui,
  arraySections: arraySections,
  pageTitle: pageTitle,
}) => {
  const { t: t } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
  const [isLoading, setIsLoading] = (0, $8zHUo$react.useState)(true);
  (0, $8zHUo$react.useEffect)(() => {
    const TO = setTimeout(() => setIsLoading(false), 290);
    return () => clearTimeout(TO);
  }, []);
  return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
    (0, $8zHUo$phpcreationfrontendcomponentsreact.PageLayout),
    {
      fqcn_bui: {
        Bundle: 'appBunlde',
        Unit: 'dashboard',
        Interface: 'homepage',
      },
      title: t(`Dashboard`),
      pageTitle: t(pageTitle || `Dashboard`),
      appNav: appNav,
      breadcrumbNav: [
        {
          label: 'Home',
          url: '/',
        },
        {
          label: 'Dashboard',
          url: '/dashboard',
        },
      ],
      children: [
        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
          id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, 'hero'),
          className: 'Hero p-4 ',
          children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('h1', {
              id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                fqcn_bui,
                'hero',
                'title'
              ),
              className:
                'text-center p-2 text-xl md:text-2xl font-semibold text-gray-800',
              children: t(heroTitle),
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('p', {
              id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                fqcn_bui,
                'hero',
                'description'
              ),
              className: 'text-gray-500 text-center md:text-sm text-xs',
              children: t(heroDesc),
            }),
          ],
        }),
        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
          className:
            'cards flex flex-wrap justify-center items-center gap-14 p-3',
          children: arraySections.map((item, index) =>
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
              (0, $8zHUo$phpcreationfrontendcomponentsreact.Card),
              {
                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
                  'div',
                  {
                    id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                      fqcn_bui,
                      item.resource + '-card'
                    ),
                    className:
                      'Card1 flex flex-col items-center w-full md:w-96 h-96 justify-around p-1 bg-white rounded-lg print:justify-center print:w-full print:m-auto',
                    children: [
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                          fqcn_bui,
                          item.resource + '-card',
                          'icon'
                        ),
                        children: [item.icon, ' '],
                      }),
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('h3', {
                        className: 'text-gray-800 font-semibold md:text-xl p-3',
                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                          fqcn_bui,
                          item.resource + '-card',
                          'title'
                        ),
                        children: t(item.title),
                      }),
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('p', {
                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                          fqcn_bui,
                          item.resource + '-card',
                          'description'
                        ),
                        className:
                          'md:text-sm text-xs text-gray-500 text-center',
                        children: t(item.desc),
                      }),
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                        (0, $parcel$interopDefault($8zHUo$nextlink)),
                        {
                          href: item.href,
                          passHref: true,
                          legacyBehavior: true,
                          children: /*#__PURE__*/ (0,
                          $8zHUo$reactjsxruntime.jsx)(
                            (0,
                            $8zHUo$phpcreationfrontendcomponentsreact.LinkButton),
                            {
                              href: item.href,
                              id: (0,
                              $14899fc8b120af69$export$c11f7f0cac96af2a)(
                                fqcn_bui,
                                item.resource + '-card',
                                'button'
                              ),
                              variant: 'primary',
                              size: 'small',
                              title: t(`Manage`),
                              onClick: () => {},
                              className: 'print:hidden',
                            }
                          ),
                        }
                      ),
                    ],
                  }
                ),
              },
              index
            )
          ),
        }),
      ],
    }
  );
};
var $babf57e211862dcf$export$2e2bcd8739ae039 = $babf57e211862dcf$var$Homepage;

const $d8558f4cea2fd4d3$export$584b2531a4ea43a = async ({
  username: username,
  password: password,
}) =>
  await (0, $parcel$interopDefault($8zHUo$axios))
    .post(process.env.NEXT_PUBLIC_CONFIG_AUTH, {
      username: username,
      password: password,
    })
    .then(res => res.data);
function $d8558f4cea2fd4d3$export$2e2bcd8739ae039() {
  const router = (0, $8zHUo$nextrouter.useRouter)();
  const { t: t } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
  return (0, $8zHUo$tanstackreactquery.useMutation)(
    ['login'],
    credentials => {
      const processedFormValues = {
        username: credentials.username.trim(),
        password: credentials.password.trim(),
      };
      return $d8558f4cea2fd4d3$export$584b2531a4ea43a(processedFormValues);
    },
    {
      onSuccess: data => {
        if (data.token)
          (0, $8zHUo$cookiesnext.setCookie)('CRUD_TOKEN', data.token);
        let toastId = (0, $parcel$interopDefault($8zHUo$reacthottoast)).success(
          t('Authenticated'),
          {
            position: 'bottom-right',
          }
        );
        setTimeout(() => {
          (0, $parcel$interopDefault($8zHUo$reacthottoast)).remove(toastId);
          router.push(
            router.query.from ? router.query.from.toString() : '/dashboard'
          );
        }, 1000);
      },
      onError: err => {
        console.error(err);
        (0, $parcel$interopDefault($8zHUo$reacthottoast)).error(
          t('Wrong Data')
        );
      },
    }
  );
}
function $d8558f4cea2fd4d3$export$f6e31faba1d0ca28() {
  const router = (0, $8zHUo$nextrouter.useRouter)();
  const { t: t } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
  return (0, $8zHUo$tanstackreactquery.useMutation)(
    ['login'],
    credentials => {
      const processedFormValues = {
        username: credentials.username.trim(),
        password: credentials.password.trim(),
      };
      return $d8558f4cea2fd4d3$export$584b2531a4ea43a(processedFormValues);
    },
    {
      onSuccess: data => {
        if (data.token) (0, $8zHUo$cookiesnext.setCookie)('CRUD_TOKEN', data);
        let taostId = (0, $parcel$interopDefault($8zHUo$reacthottoast)).success(
          'Success!'
        );
        setTimeout(() => {
          (0, $parcel$interopDefault($8zHUo$reacthottoast)).remove(taostId);
        }, 1000);
      },
      onError: () => {
        (0, $parcel$interopDefault($8zHUo$reacthottoast)).error(
          t('Wrong Data')
        );
      },
    }
  );
}

const $4b45582cae2595be$var$languages = [
  {
    label: 'Fran\xe7ais',
    value: 'fr',
  },
  {
    label: 'English',
    value: 'en',
  },
  {
    label: 'Bilingue / Bilingual',
    value: 'bi',
  },
];
const $4b45582cae2595be$var$LangSelector = props => {
  const router = (0, $8zHUo$nextrouter.useRouter)();
  const { t: t } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
  return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
    children: [
      ' ',
      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
        (0, $8zHUo$phpcreationfrontendcomponentsreact.Select),
        {
          value: $4b45582cae2595be$var$languages.filter(
            l => l.value == router.locale
          ),
          _size1: 'small',
          menuPlacement: 'top',
          placeholder: t(`choose a language`),
          options: $4b45582cae2595be$var$languages,
          onChange: newValue => {
            const asPath = router.asPath;
            router.push(
              {
                pathname: router.pathname,
                query: router.query,
              },
              asPath,
              {
                locale: newValue.value,
              }
            );
          },
          isSearchable: false,
        }
      ),
    ],
  });
};
var $4b45582cae2595be$export$2e2bcd8739ae039 =
  $4b45582cae2595be$var$LangSelector;

const $0e35b39efb2fe16d$var$FooterLogin = ({ id: id }) => {
  const [isOpen, setIsOpen] = (0, $8zHUo$react.useState)(false);
  const { t: t } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
  return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('footer', {
    id: id,
    className:
      '__bottom h-full flex flex-col items-center space-y-3 justify-end',
    children: [
      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
        id: id + '-languageSelector',
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
          (0, $4b45582cae2595be$export$2e2bcd8739ae039),
          {}
        ),
      }),
      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
        className: '',
        children: [
          /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
            (0, $8zHUo$phpcreationfrontendcomponentsreact.Button),
            {
              id: id + '-report-button',
              size: 'xsmall',
              title: t(`Report a problem`),
              onClick: () => setIsOpen(true),
              variant: 'neutral',
            }
          ),
          /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
            (0, $8zHUo$phpcreationfrontendcomponentsreact.FeedbackModal),
            {
              handleClose: () => setIsOpen(false),
              isOpen: isOpen,
            }
          ),
        ],
      }),
      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('span', {
        className: 'text-sm text-gray-500',
        children: [
          t(`Powered`),
          ' ',
          /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('b', {
            children: ' PHPCreation Inc.',
          }),
        ],
      }),
    ],
  });
};
var $0e35b39efb2fe16d$export$2e2bcd8739ae039 =
  $0e35b39efb2fe16d$var$FooterLogin;

const $35515d2b18f14e87$export$30dba1e0a1cb02c9 = {
  crud: '',
  auth: '',
  status: '',
  documentation: '',
};
const $35515d2b18f14e87$export$c5a13a81cd4fc74d = endpoints => {
  $35515d2b18f14e87$export$30dba1e0a1cb02c9.crud =
    process.env.NEXT_PUBLIC_CONFIG_CRUD ?? endpoints?.crud;
  $35515d2b18f14e87$export$30dba1e0a1cb02c9.auth =
    process.env.NEXT_PUBLIC_CONFIG_AUTH ?? endpoints.auth;
  $35515d2b18f14e87$export$30dba1e0a1cb02c9.status =
    process.env.NEXT_PUBLIC_CONFIG_STATUS ?? endpoints.status;
  $35515d2b18f14e87$export$30dba1e0a1cb02c9.documentation =
    process.env.NEXT_PUBLIC_CONFIG_DOCUMENTATION ?? endpoints.documentation;
};

const $d916a442134b0b1f$var$Login = ({
  fqcn_bui: fqcn_bui,
  devUsername: devUsername,
  devPassword: devPassword,
  sampleResource: sampleResource,
  cycle: cycle,
}) => {
  const { t: t } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
  const router = (0, $8zHUo$nextrouter.useRouter)();
  const { query: query, isReady: isReady } = router;
  const InputRef = (0, $8zHUo$react.useRef)(null);
  const InputPasswordRef = (0, $8zHUo$react.useRef)(null);
  const [isAutoTested, setIsAutoTested] = (0, $8zHUo$react.useState)(false);
  const [isLoadingToken, setIsLoadingToken] = (0, $8zHUo$react.useState)(false);
  const [formData, setFormData] = (0, $8zHUo$react.useState)({
    username: '',
    password: '',
  });
  const {
    mutate: login,
    isLoading: isLoading,
    isError: isError,
    isSuccess: isSuccess,
    data: data,
  } = (0, $d8558f4cea2fd4d3$export$2e2bcd8739ae039)();
  const {
    mutate: login_auto,
    isLoading: isLoading_query_auto,
    isError: isError_auto,
    isSuccess: isSuccess_auto,
    data: data_auto,
  } = (0, $d8558f4cea2fd4d3$export$2e2bcd8739ae039)();
  (0, $8zHUo$react.useEffect)(() => {
    if (isReady) {
      if (query.username) {
        setIsLoadingToken(true);
        setFormData({
          username: query.username.toString(),
          password: query.password ? query.password.toString() : '',
        });
        login_auto({
          username: query.username.toString(),
          password: query.password ? query.password.toString() : '',
        });
        setTimeout(() => {
          setIsAutoTested(true);
        }, 500);
      }
      // check if the token is valid
      if (query.token) {
        setIsLoadingToken(true);
        (0, $parcel$interopDefault($8zHUo$axios))
          .get(
            (0, $35515d2b18f14e87$export$30dba1e0a1cb02c9).crud +
              sampleResource +
              's',
            {
              headers: {
                Authorization: `Bearer ` + query.token,
              },
            }
          )
          .then(data => {
            setIsAutoTested(true);
            setIsLoadingToken(false);
            if (query.token)
              (0, $8zHUo$cookiesnext.setCookie)('CRUD_TOKEN', query.token);
            (0, $parcel$interopDefault($8zHUo$reacthottoast)).success(
              'Redirecting...'
            );
            setTimeout(() => {
              router.push('/dashboard');
            }, 800);
          })
          .catch(e => {
            setTimeout(() => {
              setIsAutoTested(true);
              setIsLoadingToken(false);
            }, 1000);
            setTimeout(
              () =>
                (0, $parcel$interopDefault($8zHUo$reacthottoast)).error(
                  'Invalid Token'
                ),
              1300
            );
          });
      }
    }
  }, [isReady]);
  // Password input focus on error
  (0, $8zHUo$react.useEffect)(() => {
    // if (InputRef.current) InputRef.current.focus();
    if (InputRef.current) {
      InputRef.current.value = '';
      InputRef.current.focus();
    }
  }, []);
  return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
    (0, $8zHUo$phpcreationfrontendcomponentsreact.WithSkeletonLoader),
    {
      pageTitle: t(`Log in`),
      isLoading: (isLoadingToken || isLoading_query_auto) && !isAutoTested,
      //   isLoading={true}
      skeleton: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
        (0, $8zHUo$phpcreationfrontendcomponentsreact.LoginSkeleton),
        {}
      ),
      children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, '', ''),
        className: 'grid md:grid-cols-2 grid-cols-1 min-h-screen ',
        style: {
          fontFamily: 'Roboto',
        },
        children: [
          /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
            (0, $8zHUo$reacthottoast.Toaster),
            {}
          ),
          /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('main', {
            id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
              fqcn_bui,
              'main',
              ''
            ),
            className:
              'flex flex-col items-center space-y-2 p-5 md:p-7 md:py-10 bg-white shadow-lg rounded-xl text-gray-700',
            children: [
              /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
                id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                  fqcn_bui,
                  'main',
                  'leftside-authform-logo-image'
                ),
                className: '__LOGO w-full py-1 flex items-start',
                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                  (0, $parcel$interopDefault($8zHUo$nextlink)),
                  {
                    href: '/',
                    children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                      'div',
                      {
                        className:
                          'transform scale-75 hover:scale-[0.78] px-2 py-2 mb-3 transition-transform ease-linear border-l border-gray-200 hover:border-blue-600 cursor-pointer',
                        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                          (0, $8zHUo$phpcreationfrontendcomponentsreact.Logo),
                          {}
                        ),
                      }
                    ),
                  }
                ),
              }),
              /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
                id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                  fqcn_bui,
                  'leftside-authform',
                  ''
                ),
                className: '__Center lg:pt-10 pt-5',
                children: [
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('h2', {
                    id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                      fqcn_bui,
                      'leftside-authform',
                      'login-title'
                    ),
                    className:
                      'text-2xl md:text-4xl text-gray-900 font-semibold',
                    children: t(`Log in`),
                  }),
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('form', {
                    id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                      fqcn_bui,
                      'leftside-authform'
                    ),
                    onSubmit: e => {
                      e.preventDefault();
                      login(formData);
                    },
                    className: 'flex flex-col items-center w-full ',
                    children: [
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                        (0, $8zHUo$phpcreationfrontendcomponentsreact.Input),
                        {
                          id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                            fqcn_bui,
                            'leftside-authform',
                            'username-input'
                          ),
                          label: t(`Username`),
                          autoFocus: true,
                          inputRef: InputRef,
                          state: isError ? 'error' : 'default',
                          // size="large"
                          value: formData.username,
                          required: true,
                          name: 'username',
                          onChange: e =>
                            setFormData({
                              ...formData,
                              username: e.target.value,
                            }),
                          placeholder: t(`Username`),
                          icon: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                            (0,
                            $8zHUo$phpcreationfrontendcomponentsreact.IconMailFilled),
                            {
                              className: 'w-4 h-4',
                            }
                          ),
                          iconPosition: 'right',
                        }
                      ),
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                        (0, $8zHUo$phpcreationfrontendcomponentsreact.Input),
                        {
                          id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                            fqcn_bui,
                            'leftside-authform',
                            'password-input'
                          ),
                          label: t(`Password`),
                          inputRef: InputPasswordRef,
                          state: isError ? 'error' : 'default',
                          message: isError ? 'Invalid Credentials!' : '',
                          // size="large"
                          required: true,
                          type: 'password',
                          name: 'password',
                          value: formData.password,
                          onChange: e =>
                            setFormData({
                              ...formData,
                              password: e.target.value,
                            }),
                          placeholder: t(`Password`),
                          icon: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                            (0,
                            $8zHUo$phpcreationfrontendcomponentsreact.IconLockFilled),
                            {
                              className: 'w-4 h-4',
                            }
                          ),
                          iconPosition: 'right',
                        }
                      ),
                      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
                        className:
                          '__Form__Submit flex flex-col space-y-4 w-full',
                        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                          'div',
                          {
                            className: 'flex-1',
                            children: /*#__PURE__*/ (0,
                            $8zHUo$reactjsxruntime.jsx)(
                              (0,
                              $8zHUo$phpcreationfrontendcomponentsreact.Button),
                              {
                                className: 'w-full',
                                isLoading: isLoading,
                                disabled: isLoading,
                                labelLoading: t(`Loading...`),
                                variant: 'primary',
                                size: 'large',
                                title: t('Log in'),
                                // type="submit"
                                id: (0,
                                $14899fc8b120af69$export$c11f7f0cac96af2a)(
                                  fqcn_bui,
                                  'leftside-authform',
                                  'login-button'
                                ),
                              }
                            ),
                          }
                        ),
                      }),
                    ],
                  }),
                ],
              }),
              devPassword &&
                devUsername &&
                cycle &&
                cycle == 'dev' &&
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
                  id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                    fqcn_bui,
                    'leftside-devnote'
                  ),
                  className:
                    '__DEFAULTS flex flex-col items-baseline w-96 p-8 rounded-lg',
                  children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('span', {
                      className:
                        'text-xs font-medium text-gray-500 text-center py-4 ',
                      children: t(`For dev`),
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
                      className:
                        'flex items-center justify-between w-full space-x-2 p-1 rounded-lg ',
                      children: [
                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                          className: 'text-xs font-medium text-gray-600 flex-1',
                          children: t(`Username`),
                        }),
                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('span', {
                          className:
                            'font-medium text-xs flex-1 flex justify-center',
                          children: devUsername,
                        }),
                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('span', {
                          className: 'flex-1 flex justify-end',
                          children: /*#__PURE__*/ (0,
                          $8zHUo$reactjsxruntime.jsx)(
                            (0,
                            $8zHUo$phpcreationfrontendcomponentsreact.CopyButton),
                            {
                              content: devUsername,
                            }
                          ),
                        }),
                      ],
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
                      className:
                        'flex items-center justify-between w-full space-x-2 p-1 rounded-lg ',
                      children: [
                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('label', {
                          className: 'text-xs font-medium text-gray-600 flex-1',
                          children: t(`Password`),
                        }),
                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('span', {
                          className:
                            'font-medium text-xs flex flex-1 justify-center',
                          children: devPassword,
                        }),
                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('span', {
                          className: 'flex-1 flex justify-end',
                          children: /*#__PURE__*/ (0,
                          $8zHUo$reactjsxruntime.jsx)(
                            (0,
                            $8zHUo$phpcreationfrontendcomponentsreact.CopyButton),
                            {
                              content: devPassword,
                            }
                          ),
                        }),
                      ],
                    }),
                  ],
                }),
              /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
                style: {
                  zIndex: 1,
                },
                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                  (0, $0e35b39efb2fe16d$export$2e2bcd8739ae039),
                  {
                    id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                      fqcn_bui,
                      'footer'
                    ),
                  }
                ),
              }),
            ],
          }),
          /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
            className:
              'Left-side md:block hidden bg-gradient-to-r from-blue-500 to-blue-500 justify-center items-center',
            children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
              className: 'w-full h-full flex justify-center items-center ',
              children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
                className: 'w-3/5 h-3/5 ',
                children: [
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
                    className: ' bg-white w-28 px-5 py-2 rounded-lg ml-20 my-2',
                    children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                      (0, $8zHUo$phpcreationfrontendcomponentsreact.Logo),
                      {}
                    ),
                  }),
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.LoginSvg),
                    {}
                  ),
                ],
              }),
            }),
          }),
        ],
      }),
    }
  );
};
var $d916a442134b0b1f$export$2e2bcd8739ae039 = $d916a442134b0b1f$var$Login;

const $ab70f9113dab70ed$export$423bb2cf04f7e0bb = async () => {
  try {
    return await (0, $parcel$interopDefault($8zHUo$axios))
      .get((0, $35515d2b18f14e87$export$30dba1e0a1cb02c9).status)
      .then(res => res);
  } catch (e) {
    return [];
  }
};
const $ab70f9113dab70ed$export$7f0ed83521fba7cb = async (resource, id, jwt) =>
  (0, $parcel$interopDefault($8zHUo$axios))
    .get(
      (0, $35515d2b18f14e87$export$30dba1e0a1cb02c9).crud +
        '/' +
        resource +
        '/' +
        id,
      {
        headers: {
          Authorization: `Bearer ${jwt}`,
        },
      }
    )
    .then(res => res);
const $ab70f9113dab70ed$export$3ac1f382cf85e39b = async (resource, jwt) =>
  (0, $parcel$interopDefault($8zHUo$axios))
    .get((0, $35515d2b18f14e87$export$30dba1e0a1cb02c9).crud + '/' + resource, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    })
    .then(res => res);
const $ab70f9113dab70ed$export$5239e329ba02d09b = async (
  resource,
  jsonPath,
  jwt
) =>
  (0, $parcel$interopDefault($8zHUo$axios))
    .get(
      (0, $35515d2b18f14e87$export$30dba1e0a1cb02c9).crud +
        '/' +
        resource +
        '/' +
        jsonPath,
      {
        headers: {
          Authorization: `Bearer ${jwt}`,
        },
      }
    )
    .then(res => res);
const $ab70f9113dab70ed$export$f80d1eb87df81586 = async link =>
  (0, $parcel$interopDefault($8zHUo$axios)).get(link).then(res => res);
const $ab70f9113dab70ed$export$880a166440c2a826 = async (link, jwt) =>
  (0, $parcel$interopDefault($8zHUo$axios))
    .get(link, {
      headers: {
        Authorization: `bearer ${jwt}`,
      },
    })
    .then(res => res);

function $57877cc6648422f5$export$cc7de1bcbd27d0a2() {
  return (0, $8zHUo$tanstackreactquery.useQuery)(['status'], () =>
    (0, $ab70f9113dab70ed$export$423bb2cf04f7e0bb)()
  );
}

const $b8f3178562702f6a$var$Status = ({ fqcn_bui: fqcn_bui }) => {
  const {
    isLoading: isLoading,
    isSuccess: isSuccess,
    data: data,
    isRefetching: isRefetching,
    isError: isError,
    refetch: refetch,
    status: status,
  } = (0, $57877cc6648422f5$export$cc7de1bcbd27d0a2)();
  const {
    isLoading: isLoadingToken,
    isSuccess: isSuccessGetToken,
    mutate: getToken,
    data: dataToken,
  } = (0, $d8558f4cea2fd4d3$export$f6e31faba1d0ca28)();
  const copyToken = token => {
    window.navigator.clipboard.writeText(`bearer ${token}`);
    (0, $parcel$interopDefault($8zHUo$reacthottoast)).success('copied');
  };
  (0, $8zHUo$react.useEffect)(() => {
    //@ts-ignore
    if (
      (0, $35515d2b18f14e87$export$30dba1e0a1cb02c9).status &&
      !data?.data.Status
    )
      refetch();
  }, [(0, $35515d2b18f14e87$export$30dba1e0a1cb02c9).status, data]);
  //@ts-ignore
  if (isLoading || isRefetching || !data?.data.Status)
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
      (0, $8zHUo$phpcreationfrontendcomponentsreact.Loader),
      {
        isLoading: true,
      }
    );
  return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
    className: 'flex flex-col min-h-screen',
    style: {
      fontFamily: 'Roboto',
    },
    children: [
      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
        (0, $parcel$interopDefault($8zHUo$nexthead)),
        {
          children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('title', {
              children: 'Status',
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('meta', {
              name: 'description',
              content: 'phpreaction prototype',
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('link', {
              rel: 'icon',
              href: '/favicon.ico',
            }),
          ],
        }
      ),
      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
        (0, $8zHUo$reacthottoast.Toaster),
        {}
      ),
      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('main', {
        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, ''),
        className: 'flex flex-col pt-10 items-center h-screen bg-gray-100',
        children: [
          /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('h1', {
            className: 'text-2xl font-medium p-3 pt-2 pb-7',
            children: 'Backend Status ',
          }),
          /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
            className:
              '__TAble flex flex-col space-y-2 p-3 border border-gray-300 shadow-sm rounded-lg bg-white ',
            children: [
              /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
                className: '__HEADER grid grid-cols-5 gap-4',
                children: [
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('span', {
                    id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                      fqcn_bui,
                      'endpoint',
                      'endpoint-text'
                    ),
                    className: 'text-sm font-medium text-gray-600 ',
                    children: 'Endpoint',
                  }),
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('span', {
                    className: 'text-sm font-medium text-gray-600 ',
                    children: 'Status Code',
                  }),
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('span', {
                    className: 'text-sm font-medium text-gray-600 ',
                    children: 'Status',
                  }),
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('span', {
                    className: 'text-sm font-medium text-gray-600 ',
                    children: 'Sumarry',
                  }),
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('span', {
                    className: 'text-sm font-medium text-gray-600 ',
                    children: 'Documentation',
                  }),
                ],
              }),
              (isLoading || isRefetching) &&
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
                  className:
                    '__Row_Loding grid grid-cols-5 gap-4 animate-pulse',
                  children: [1, 2, 3, 4, 5].map(i =>
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                      'span',
                      {
                        className: `${
                          i == 1 ? 'w-40 md:w-72' : 'w-28 md:w-36'
                        } h-2 bg-gray-200`,
                      },
                      i
                    )
                  ),
                }),
              !isLoading &&
                !isRefetching &&
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
                  className: '__Row grid grid-cols-5 gap-4 ',
                  children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('span', {
                      className:
                        ' font-medium text-gray-800 md:text-base text-sm',
                      children: '/api/login_check',
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('span', {
                      id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(
                        fqcn_bui,
                        'status',
                        'status'
                      ),
                      className:
                        ' font-medium text-gray-800 md:text-base text-sm',
                      //@ts-ignore
                      children: data?.status,
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('span', {
                      className:
                        ' font-medium text-gray-800 md:text-base text-sm ',
                      //@ts-ignore
                      children: data?.data.Status,
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
                      //@ts-ignore
                      children:
                        data?.data.Status.toLowerCase() == 'ok'
                          ? /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                              'span',
                              {
                                children: /*#__PURE__*/ (0,
                                $8zHUo$reactjsxruntime.jsx)(
                                  (0,
                                  $8zHUo$phpcreationfrontendcomponentsreact.IconGlyphCheck),
                                  {
                                    fill: 'green',
                                    className: 'w-10 h-10 text-green-600',
                                  }
                                ),
                              }
                            )
                          : /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                              'span',
                              {
                                children: /*#__PURE__*/ (0,
                                $8zHUo$reactjsxruntime.jsx)(
                                  (0,
                                  $8zHUo$phpcreationfrontendcomponentsreact.IconGlyphTimes),
                                  {
                                    fill: 'green',
                                    className: 'w-10 h-10 text-red-600',
                                  }
                                ),
                              }
                            ),
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('a', {
                      href: (0, $35515d2b18f14e87$export$30dba1e0a1cb02c9)
                        .documentation,
                      className:
                        ' font-medium text-blue-700 underline md:text-base text-xs md:w-auto w-2 ',
                      target: '_blank',
                      rel: 'noreferrer',
                      children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                        (0,
                        $8zHUo$phpcreationfrontendcomponentsreact.IconGlyphBook),
                        {
                          fill: 'black',
                          className: 'w-10 h-10',
                        }
                      ),
                    }),
                  ],
                }),
            ],
          }),
          /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
            className: '__Actions w-full p-10 flex justify-center',
            children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
              className: ' w-80 p-3 space-y-4',
              children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
                className: 'grid grid-cols-2 gap-10',
                children: [
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.Button),
                    {
                      size: 'small',
                      title: 'Api/status',
                      onClick: () => {
                        location.href =
                          'https://dev.phpreaction-crud.phpr.link/api/status';
                      },
                    }
                  ),
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.Button),
                    {
                      size: 'small',
                      title: 'Api/status-all',
                      onClick: () => {
                        location.href =
                          'https://dev.phpreaction-crud.phpr.link/api/status-all';
                      },
                    }
                  ),
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.Button),
                    {
                      size: 'small',
                      title: 'Api/status-api',
                      onClick: () => {
                        location.href =
                          'https://dev.phpreaction-crud.phpr.link/api/status-api';
                      },
                    }
                  ),
                  document.location.pathname == '/fr/status-api/view' ||
                  document.location.pathname == '/status-api/view'
                    ? null
                    : /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                        (0, $parcel$interopDefault($8zHUo$nextlink)),
                        {
                          href: '/status-api/view',
                          children: /*#__PURE__*/ (0,
                          $8zHUo$reactjsxruntime.jsx)(
                            (0,
                            $8zHUo$phpcreationfrontendcomponentsreact.Button),
                            {
                              size: 'small',
                              variant: 'secondary',
                              title: '/status-api/view',
                            }
                          ),
                        }
                      ),
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.Button),
                    {
                      size: 'small',
                      title: 'Test Api',
                      onClick: () => refetch(),
                    }
                  ),
                  /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                    (0, $8zHUo$phpcreationfrontendcomponentsreact.Button),
                    {
                      size: 'small',
                      variant: 'secondary',
                      title: 'Get Token',
                      onClick: () =>
                        getToken({
                          username: 'admin',
                          password: 'phpc',
                        }),
                    }
                  ),
                ],
              }),
            }),
          }),
          isLoadingToken &&
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
              className: 'w-80 h-3 bg-gray-300 animate-pulse',
            }),
          isSuccessGetToken &&
            dataToken &&
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('div', {
              className: 'flex flex-col items-center container',
              children: [
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('p', {
                  children: 'Token',
                }),
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('div', {
                  onClick: () => copyToken(dataToken.token),
                  className:
                    '__Token flex flex-col space-y-2 p-3 border border-gray-300 shadow-sm rounded-lg bg-white cursor-pointer hover:text-gray-700 ',
                  children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('p', {
                    className: 'overflow-hidden truncate w-80',
                    children: 'bearer ' + dataToken.token,
                  }),
                }),
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)('span', {
                  onClick: () => copyToken(dataToken.token),
                  className:
                    'text-sm font-light text-gray-500 p-1 italic flex items-stretch space-x-1',
                  children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('span', {
                      className: 'self-center',
                      children: 'Click to copy',
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
                      (0,
                      $8zHUo$phpcreationfrontendcomponentsreact.IconClipboard),
                      {
                        className: 'w-5 h-5 text-gray-500',
                      }
                    ),
                  ],
                }),
              ],
            }),
        ],
      }),
      /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)('footer', {
        className: '',
      }),
    ],
  });
};
var $b8f3178562702f6a$export$2e2bcd8739ae039 = $b8f3178562702f6a$var$Status;

//

var $c95adea1dc38c354$exports = {};
$c95adea1dc38c354$exports = JSON.parse(
  '{"Add":"Add","Add ":"Add ","add":"Add","Filters":"Filters","filters":"filters","Filter":"Filter","filter":"filter","Stack":"Stack","stack":"stack","Log in":"Log in","Log out":"Log out","Forgot password?":"Forgot password?","Username":"Username","Password":"Password","Loading...":"Loading...","For dev":"For development purposes, the following credentials are valid in order to access the application.","Powered":"Powered by ","Authenticated":"Authenticated","Wrong Data":"Wrong Data","Success!":"Success!","Dashboard":"Dashboard","Report a problem":"Report a problem","Bug report":"Bug report","Welcome on Board":"Welcome on Board","Manage":"Manage","Selected fields":"Selected fields","Selected actions":"Selected actions","Cancel":"Cancel","Confirm":"Confirm","Delete ":"Delete ","Duplicate ":"Duplicate ","Close ":"Close","close ":"close","Edit":"Edit","edit":"edit","Create":"Create","Name":"Name","name":"name","Do you really want to delete this":"Do you really want to delete this ","new":"new","Home":"Home","search":"Search","fields":"Fields","exports":"Exports","Actions":"Actions","actions":"actions","Action":"Action","action":"action","print":"Print","clear":"clear","apply":"apply","show":"show","delete":"delete","duplicate":"duplicate","Quick":"Quick","detailed":"detailed","Tour":"Tour","value":"value","Value":"Value","id":"id","information":"information","select Id from the list":"select Id from the list","input the name":"input the name","input the value":"input the value","input the stack":"input the value","Click to sort by descending":"Click to sort by descending","Click to sort by ascending":"Click to sort by ascending","Click to cancel sorting":"Click to cancel sorting","Hostnames":"Hostnames","hostnames":"hostnames","Hostname":"Hostname","hostname":"hostname","hostnames ID":"Hostname ID","Hostname ID":"Hostname ID","Tenants":"Tenants","tenants":"tenants","Tenant":"Tenant","tenant":"tenant","tenant.id":"tenant","tenants ID":"Tenant ID","Tenant ID":"Tenant ID","Parameters":"Parameters","parameters":"parameters","Parameter":"Parameter","parameter":"parameter","parameters ID":"Parameter ID","Parameter ID":"Parameter ID","Our users can use this platform to manage the tenants, hostnames, parameters, and many more features to discover!":"Our users can use this platform to manage the tenants, hostnames, parameters, and many more features to discover!","Manage tenants":"Manage tenants","Manage hostnames":"Manage hostnames","Change parameters":"Change parameters","Overview of the tenants, simple way to manage every aspect.":"Overview of the tenants, simple way to manage every aspect.","Configure hostnames, search hostnames and more features.":"Configure hostnames, search hostnames and more features.","Manage parameters tied to each tenant, easy way to filter and configure.":"Manage parameters tied to each tenant, easy way to filter and configure.","Select a tenant id":"Select a tenant id","hostnames Listing":"Hostnames Listing","tenants Listing":"Tenants Listing","parameters Listing":"Parameters Listing","Select tenant ID":"Select tenant ID","Search hostname":"Search hostname","Search tenant name":"Search tenant name","input the hostname":"input the hostname","Support plan":"Support plan","Emergency":"Emergency","Request or Problem*":"Request or Problem*","First name*":"First name*","Last name*":"Last name*","Email Address*":"Email Address*","Phone*":"Phone*","URL*":"URL*","Send":"Send","Your request/description has been received.":"Your request/description has been received.","You will receive a follow up shortly.":"You will receive a follow up shortly.","Note the confirmation number :":"Note the confirmation number :","View/manage your ticket here :":"View/manage your ticket here :","Click here to view ticket":"Click here to view ticket","New Ticket":"New Ticket"}'
);

var $f07e6a0fc979bd24$exports = {};
$f07e6a0fc979bd24$exports = JSON.parse(
  '{"Add":"Ajouter","Add ":"Ajouter ","add":"Ajout","Filters":"Filtres","filters":"filtres","Filter":"Filtre","filter":"filtre","Stack":"Empiler","stack":"empiler","Stacks":"Instances","stacks":"instances","Log in":"Connexion","Log out":"Se d\xe9connecter","Forgot password?":"Mot de passe oubli\xe9?","Username":"Nom d\'utilisateur","Password":"Mot de passe","Loading...":"Chargement...","For dev":"Les informations d\'identification suivantes sont fournies aux d\xe9veloppeurs pour naviguer l\'application.","Powered":"Propuls\xe9 par","Authenticated":"Authentifi\xe9","Wrong Data":"Donn\xe9es erron\xe9es","Success!":"Succ\xe8s!","Dashboard":"Tableau de bord","Report a problem":"Signaler un probl\xe8me","Bug report":"rapport d\'erreur","Welcome on Board":"Bienvenue!","Manage":"G\xe9rer","Selected fields":"Champs s\xe9lectionn\xe9","Selected actions":"Actions s\xe9lectionn\xe9","Cancel":"Annuler","Confirm":"Confirmer","Delete ":"Supprimer ","Delete":"Supprimer","Duplicate ":"Dupliquer ","Close ":"Fermer","close ":"fermer","Edit":"Modifier","edit":"modifier","Create":"Cr\xe9er","Name":"Nom","name":"nom","Do you really want to delete this":"Voulez-vous vraiment supprimer ce ","new":"nouveau","Home":"Accueil","search":"Chercher","fields":"Des champs","exports":"Exporter","Actions":"Actions","actions":"actions","Action":"Action","action":"action","print":"Imprimer","Print":"Imprimer","clear":"effacer","apply":"Appliquer","Apply":"Appliquer","show":"afficher","delete":"supprimer","duplicate":"dupliquer","Quick":"Rapide","detailed":"D\xe9taill\xe9","Detailed":"D\xe9taill\xe9","Tour":"Guide","value":"valeur","Value":"Valeur","id":"id","information":"informations","select Id from the list":"s\xe9lectionn\xe9 un id a partir de la liste","input the name":"saisir le nom","input the value":"saisir la valeur","input the stack":"saisir le paquet","Click to sort by descending":"Cliquez pour trier par ordre d\xe9croissant","Click to sort by ascending":"Cliquez pour trier par ordre croissant","Click to cancel sorting":"Cliquez pour annuler le triage","tickets":"billets","Open ticket":"Ouvrir billet","Close ticket":"Fermer billet","Hostnames":"Noms d\'h\xf4tes","hostnames":"noms d\'h\xf4tes","Hostname":"Nom d\'h\xf4te","hostname":"nom d\'h\xf4te","hostnames ID":"ID du nom d\'h\xf4te","Hostname ID":"ID du nom d\'h\xf4te","Tenants":"Comptes","tenants":"comptes","Tenant":"Compte","tenant":"compte","tenant.id":"compte","tenants ID":"ID du compte","Tenant ID":"ID du compte","Parameters":"Param\xe8tres","parameters":"param\xe8tres","Parameter":"Param\xe8tre","parameter":"param\xe8tre","parameters ID":"ID du param\xe8tre","Parameter ID":"ID du param\xe8tre","Our users can use this platform to manage the tenants, hostnames, parameters, and many more features to discover!":"Nos utilisateurs peuvent utiliser cette plateforme pour g\xe9rer les locataires, les noms d\'h\xf4tes, les param\xe8tres et bien d\'autres fonctionnalit\xe9s \xe0 d\xe9couvrir !","Manage tenants":"Gestion des comptes","Manage hostnames":"Gestion des noms d\'h\xf4tes","Change parameters":"Gestion des param\xe8tres","Overview of the tenants, simple way to manage every aspect.":"Vue d\'ensemble des comptes, moyen simple de g\xe9rer tous les aspects.","Configure hostnames, search hostnames and more features.":"Configuration des noms d\'h\xf4tes, recherche de noms d\'h\xf4tes et autres fonctionnalit\xe9s.","Manage parameters tied to each tenant, easy way to filter and configure.":"Gestion des param\xe8tres li\xe9s \xe0 chaque comptes, moyen facile de filtrer et de configurer.","Select a tenant id":"s\xe9lectionn\xe9 un compte","hostnames Listing":"Liste des noms d\'h\xf4tes","tenants Listing":"Liste des comptes","parameters Listing":"Liste des param\xe8tres","Select tenant ID":"S\xe9lectionn\xe9 un ID de compte","Search hostname":"Chercher par nom d\'h\xf4te","Search tenant name":"Chercher par nom de compte","input the hostname":"saisir le nom d\'h\xf4te","Support plan":"Plan de support","Emergency":"Urgence","Request or Problem*":"Demande ou Probl\xe8me*","First name*":"Pr\xe9nom*","Last name*":"Nom*","Email Address*":"Adresse Courriel*","Phone*":"T\xe9l\xe9phone*","URL*":"URL*","Send":"Envoyer","Your request/description has been received.":"Votre demande/description de probl\xe9matique a bien \xe9t\xe9 re\xe7ue","You will receive a follow up shortly.":"Vous recevrez un suivi sous peu","Note the confirmation number :":"Notez le num\xe9ro de confirmation suivant","View/manage your ticket here :":"Consultez/g\xe9rez votre ticke t au lien suivant","Click here to view ticket":"Cliquez ici pour voir le ticket","New Ticket":"Nouveau Ticket","Last updated":"Mise \xe0 jour","Created":"Cr\xe9\xe9","Shortcode":"code bref","UID":"UID","System":"syst\xe8me"}'
);

var $097b622f1a57422e$exports = {};
$097b622f1a57422e$exports = JSON.parse(
  '{"Add":"Add","Add ":"Add ","add":"Add","Filters":"Filters","filters":"filters","Filter":"Filter","filter":"filter","Stack":"Stack","stack":"stack","Log in":"Log in","Log out":"Log out","Forgot password?":"Forgot password?","Username":"Username","Password":"Password","Loading...":"Loading...","For dev":"For development purposes, the following credentials are valid in order to access the application.","Powered":"Powered by ","Authenticated":"Authenticated","Wrong Data":"Wrong Data","Success!":"Success!","Dashboard":"Dashboard","Report a problem":"Report a problem","Bug report":"Bug report","Welcome on Board":"Welcome on Board","Manage":"Manage","Selected fields":"Selected fields","Selected actions":"Selected actions","Cancel":"Cancel","Confirm":"Confirm","Delete ":"Delete ","Duplicate ":"Duplicate ","Close ":"Close","close ":"close","Edit":"Edit","edit":"edit","Create":"Create","Name":"Name","name":"name","Do you really want to delete this":"Do you really want to delete this ","new":"new","Home":"Home","search":"Search","fields":"Fields","exports":"Exports","Actions":"Actions","actions":"actions","Action":"Action","action":"action","print":"Print","clear":"clear","apply":"apply","show":"show","delete":"delete","duplicate":"duplicate","Quick":"Quick","detailed":"detailed","Tour":"Tour","value":"value","Value":"Value","id":"id","information":"information","select Id from the list":"select Id from the list","input the name":"input the name","input the value":"input the value","input the stack":"input the value","Click to sort by descending":"Click to sort by descending","Click to sort by ascending":"Click to sort by ascending","Click to cancel sorting":"Click to cancel sorting","Hostnames":"Hostnames","hostnames":"hostnames","Hostname":"Hostname","hostname":"hostname","hostnames ID":"Hostname ID","Hostname ID":"Hostname ID","Tenants":"Tenants","tenants":"tenants","Tenant":"Tenant","tenant":"tenant","tenant.id":"tenant","tenants ID":"Tenant ID","Tenant ID":"Tenant ID","Parameters":"Parameters","parameters":"parameters","Parameter":"Parameter","parameter":"parameter","parameters ID":"Parameter ID","Parameter ID":"Parameter ID","Our users can use this plateform to manage the tenants, hostnames ,paramters and much more features to discover!":"Our users can use this plateform to manage the tenants, hostnames , paramters and much more features to discover!","Manage tenants":"Manage tenants","Manage hostnames":"Manage hostnames","Change parameters":"Change parameters","Overview of the tenants, simple way to manage every aspect.":"Overview of the tenants, simple way to manage every aspect.","Configure hostnames, search hostnames and more features.":"Configure hostnames, search hostnames and more features.","Manage parameters tied to each tenant, easy way to filter and configure.":"Manage parameters tied to each tenant, easy way to filter and configure.","Select a tenant id":"Select a tenant id","hostnames Listing":"Hostnames Listing","tenants Listing":"Tenants Listing","parameters Listing":"Parameters Listing","Select tenant ID":"Select tenant ID","Search hostname":"Search hostname","Search tenant name":"Search tenant name","input the hostname":"input the hostname","Support plan":"Plan de support / Support plan","Emergency":"Urgence /\xa0Emergency","Request or Problem*":"Demande ou Probl\xe8me* / Request or Problem*","First name*":"Pr\xe9nom* / First name*","Last name*":"Nom* / Last name*","Email Address*":"Adresse Courriel* / Email Address*","Phone*":"T\xe9l\xe9phone* / Phone*","URL*":"URL*","Send":"Envoyer / Send","Your request/description has been received.":"Votre demande/description de probl\xe9matique a bien \xe9t\xe9 re\xe7ue / Your request/description has been received.","You will receive a follow up shortly.":"Vous recevrez un suivi sous peu / You will receive a follow up shortly.","Note the confirmation number :":"Notez le num\xe9ro de confirmation suivant / Note the confirmation number :","View/manage your ticket here :":"Consultez/g\xe9rez votre ticket au lien suivant / View/manage your ticket here :","Click here to view ticket":"Cliquez ici pour voir le ticket / Click here to view ticket","New Ticket":"Nouveau Ticket / New Ticket"}'
);

const $c022715bc9d219e1$var$messages = {
  en: /*@__PURE__*/ $parcel$interopDefault($c95adea1dc38c354$exports),
  fr: /*@__PURE__*/ $parcel$interopDefault($f07e6a0fc979bd24$exports),
  bi: /*@__PURE__*/ $parcel$interopDefault($097b622f1a57422e$exports),
};
const $c022715bc9d219e1$var$AppContext = ({
  children: children,
  endpoints: endpoints,
  extraMessages: extraMessages,
}) => {
  const { locale: locale } = (0, $8zHUo$nextrouter.useRouter)();
  const [queryClient] = (0, $parcel$interopDefault($8zHUo$react)).useState(
    () =>
      new (0, $8zHUo$tanstackreactquery.QueryClient)({
        defaultOptions: {
          queries: {
            staleTime: 30000,
            retry: false,
            refetchOnWindowFocus: true,
            refetchOnMount: true,
          },
        },
      })
  );
  (0, $8zHUo$react.useEffect)(() => {
    (0, $35515d2b18f14e87$export$c5a13a81cd4fc74d)(endpoints);
    (0, $c7d5b4ea505ed32f$export$2e2bcd8739ae039).defaults.baseURL = (0,
    $35515d2b18f14e87$export$30dba1e0a1cb02c9).crud;
    if (extraMessages) {
      Object.assign($c022715bc9d219e1$var$messages.en, extraMessages.en);
      Object.assign($c022715bc9d219e1$var$messages.fr, extraMessages.fr);
      Object.assign($c022715bc9d219e1$var$messages.bi, extraMessages.bi);
    }
  }, []);
  return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)(
    (0, $8zHUo$tanstackreactquery.QueryClientProvider),
    {
      client: queryClient,
      children: [
        // issue: local can be undefined,but this is already hundled by Next.js
        //@ts-ignore
        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
          (0, $8zHUo$reactintl.IntlProvider),
          {
            locale: locale,
            messages: $c022715bc9d219e1$var$messages[locale],
            children: children,
          }
        ),
        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)(
          (0, $8zHUo$tanstackreactquerydevtools.ReactQueryDevtools),
          {
            initialIsOpen: false,
          }
        ),
      ],
    }
  );
};
var // export default MyApp;
  $c022715bc9d219e1$export$2e2bcd8739ae039 = $c022715bc9d219e1$var$AppContext;

//# sourceMappingURL=index.js.map
